var items = {
  "block.minecraft.acacia_button": "Akaziazko botoia",
  "block.minecraft.acacia_door": "Akaziazko atea",
  "block.minecraft.acacia_fence": "Akaziazko hesia",
  "block.minecraft.acacia_fence_gate": "Akaziazko hesi atea",
  "block.minecraft.acacia_hanging_sign": "Akaziazko kartel eskegia",
  "block.minecraft.acacia_leaves": "Akazia hostoak",
  "block.minecraft.acacia_log": "Akazia enborra",
  "block.minecraft.acacia_planks": "Akazia oholak",
  "block.minecraft.acacia_pressure_plate": "Akaziazko presio plaka",
  "block.minecraft.acacia_sapling": "Akazia kimua",
  "block.minecraft.acacia_shelf": "Akaziazko apala",
  "block.minecraft.acacia_sign": "Akaziazko kartela",
  "block.minecraft.acacia_slab": "Akaziazko lauza",
  "block.minecraft.acacia_stairs": "Akaziazko eskailerak",
  "block.minecraft.acacia_trapdoor": "Akaziazko tranpola",
  "block.minecraft.acacia_wall_hanging_sign": "Akaziazko kartel eskegia horman",
  "block.minecraft.acacia_wall_sign": "Akaziazko kartela horman",
  "block.minecraft.acacia_wood": "Akazia egurra",
  "block.minecraft.activator_rail": "Aktibatzailedun erraila",
  "block.minecraft.air": "Airea",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Ametista blokea",
  "block.minecraft.amethyst_cluster": "Ametista-mordoa",
  "block.minecraft.ancient_debris": "Antzinako hondakinak",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Andesitazko lauza",
  "block.minecraft.andesite_stairs": "Andesita eskailerak",
  "block.minecraft.andesite_wall": "Andesitazko pareta",
  "block.minecraft.anvil": "Ingude",
  "block.minecraft.attached_melon_stem": "Angurri zurtoin lotuta",
  "block.minecraft.attached_pumpkin_stem": "Erantsitako kalabaza zurtoina",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalearen hostoak",
  "block.minecraft.azure_bluet": "Bluet urdin argia",
  "block.minecraft.bamboo": "Banbua",
  "block.minecraft.bamboo_block": "Banbu blokea",
  "block.minecraft.bamboo_button": "Banbuzko botoia",
  "block.minecraft.bamboo_door": "Banbuzko atea",
  "block.minecraft.bamboo_fence": "Banbuzko hesia",
  "block.minecraft.bamboo_fence_gate": "Banbuzko hesi atea",
  "block.minecraft.bamboo_hanging_sign": "Banbuzko kartel eskegia",
  "block.minecraft.bamboo_mosaic": "Banbuzko mosaikoa",
  "block.minecraft.bamboo_mosaic_slab": "Banbuzko mosaiko lauza",
  "block.minecraft.bamboo_mosaic_stairs": "Banbuzko mosaiko eskailerak",
  "block.minecraft.bamboo_planks": "Banbuzko oholak",
  "block.minecraft.bamboo_pressure_plate": "Banbuzko presio plaka",
  "block.minecraft.bamboo_sapling": "Banbu aldaxka",
  "block.minecraft.bamboo_shelf": "Banbuzko apala",
  "block.minecraft.bamboo_sign": "Banbuzko seinalea",
  "block.minecraft.bamboo_slab": "Banbuzko lauza",
  "block.minecraft.bamboo_stairs": "Banbuzko eskailerak",
  "block.minecraft.bamboo_trapdoor": "Banbuzko tranpola",
  "block.minecraft.bamboo_wall_hanging_sign": "Banbuzko kartel eskegia horman",
  "block.minecraft.bamboo_wall_sign": "Banbuzko hormako seinalea",
  "block.minecraft.banner.base.black": "Hondo beltz osoa",
  "block.minecraft.banner.base.blue": "Hondo urdin osoa",
  "block.minecraft.banner.base.brown": "Hondo marroi osoa",
  "block.minecraft.banner.base.cyan": "Hondo zian osoa",
  "block.minecraft.banner.base.gray": "Hondo gris osoa",
  "block.minecraft.banner.base.green": "Hondo berde osoa",
  "block.minecraft.banner.base.light_blue": "Hondo urdin argi osoa",
  "block.minecraft.banner.base.light_gray": "Hondo gris argi osoa",
  "block.minecraft.banner.base.lime": "Hondo lima osoa",
  "block.minecraft.banner.base.magenta": "Hondo magenta osoa",
  "block.minecraft.banner.base.orange": "Hondo laranja osoa",
  "block.minecraft.banner.base.pink": "Hondo arrosa osoa",
  "block.minecraft.banner.base.purple": "Hondo more osoa",
  "block.minecraft.banner.base.red": "Hondo gorri osoa",
  "block.minecraft.banner.base.white": "Hondo zuri osoa",
  "block.minecraft.banner.base.yellow": "Hondo hori osoa",
  "block.minecraft.banner.border.black": "Ertz beltza",
  "block.minecraft.banner.border.blue": "Ertz urdina",
  "block.minecraft.banner.border.brown": "Ertz marroia",
  "block.minecraft.banner.border.cyan": "Ertz ziana",
  "block.minecraft.banner.border.gray": "Ertz grisa",
  "block.minecraft.banner.border.green": "Ertz berdea",
  "block.minecraft.banner.border.light_blue": "Ertz urdin argia",
  "block.minecraft.banner.border.light_gray": "Ertz gris argia",
  "block.minecraft.banner.border.lime": "Ertz lima",
  "block.minecraft.banner.border.magenta": "Ertz magenta",
  "block.minecraft.banner.border.orange": "Ertz laranja",
  "block.minecraft.banner.border.pink": "Ertz arrosa",
  "block.minecraft.banner.border.purple": "Ertz morea",
  "block.minecraft.banner.border.red": "Ertz gorria",
  "block.minecraft.banner.border.white": "Ertz zuria",
  "block.minecraft.banner.border.yellow": "Ertz horia",
  "block.minecraft.banner.bricks.black": "Harlanduzko hondo beltza",
  "block.minecraft.banner.bricks.blue": "Harlanduzko hondo urdina",
  "block.minecraft.banner.bricks.brown": "Harlanduzko hondo marroia",
  "block.minecraft.banner.bricks.cyan": "Harlanduzko hondo ziana",
  "block.minecraft.banner.bricks.gray": "Harlanduzko hondo grisa",
  "block.minecraft.banner.bricks.green": "Harlanduzko hondo berdea",
  "block.minecraft.banner.bricks.light_blue": "Harlanduzko hondo urdin argia",
  "block.minecraft.banner.bricks.light_gray": "Harlanduzko hondo gris argia",
  "block.minecraft.banner.bricks.lime": "Harlanduzko hondo lima",
  "block.minecraft.banner.bricks.magenta": "Harlanduzko hondo magenta",
  "block.minecraft.banner.bricks.orange": "Harlanduzko hondo naranja",
  "block.minecraft.banner.bricks.pink": "Harlanduzko hondo arrosa",
  "block.minecraft.banner.bricks.purple": "Harlanduzko hondo morea",
  "block.minecraft.banner.bricks.red": "Harlanduzko hondo gorria",
  "block.minecraft.banner.bricks.white": "Harlanduzko hondo zuria",
  "block.minecraft.banner.bricks.yellow": "Harlanduzko hondo horia",
  "block.minecraft.banner.circle.black": "Biribil beltza",
  "block.minecraft.banner.circle.blue": "Biribil urdina",
  "block.minecraft.banner.circle.brown": "Biribil marroia",
  "block.minecraft.banner.circle.cyan": "Biribil ziana",
  "block.minecraft.banner.circle.gray": "Biribil grisa",
  "block.minecraft.banner.circle.green": "Biribil berdea",
  "block.minecraft.banner.circle.light_blue": "Biribil urdin argia",
  "block.minecraft.banner.circle.light_gray": "Biribil gris argia",
  "block.minecraft.banner.circle.lime": "Biribil lima",
  "block.minecraft.banner.circle.magenta": "Biribil magenta",
  "block.minecraft.banner.circle.orange": "Biribil laranja",
  "block.minecraft.banner.circle.pink": "Biribil larrosa",
  "block.minecraft.banner.circle.purple": "Biribil morea",
  "block.minecraft.banner.circle.red": "Biribil gorria",
  "block.minecraft.banner.circle.white": "Biribil zuria",
  "block.minecraft.banner.circle.yellow": "Biribil horia",
  "block.minecraft.banner.creeper.black": "Creeper beltz kargatua",
  "block.minecraft.banner.creeper.blue": "Creeper urdin kargatua",
  "block.minecraft.banner.creeper.brown": "Creeper marroi kargatua",
  "block.minecraft.banner.creeper.cyan": "Creeper zian kargatua",
  "block.minecraft.banner.creeper.gray": "Creeper gris kargatua",
  "block.minecraft.banner.creeper.green": "Creeper berde kargatua",
  "block.minecraft.banner.creeper.light_blue": "Creeper urdin argi kargatua",
  "block.minecraft.banner.creeper.light_gray": "Creeper gris argi kargatua",
  "block.minecraft.banner.creeper.lime": "Creeper lima kargatua",
  "block.minecraft.banner.creeper.magenta": "Creeper magenta kargatua",
  "block.minecraft.banner.creeper.orange": "Creeper laranja kargatua",
  "block.minecraft.banner.creeper.pink": "Creeper arrosa kargatua",
  "block.minecraft.banner.creeper.purple": "Creeper more kargatua",
  "block.minecraft.banner.creeper.red": "Creeper gorri kargatua",
  "block.minecraft.banner.creeper.white": "Creeper zuri kargatua",
  "block.minecraft.banner.creeper.yellow": "Creeper hori kargatua",
  "block.minecraft.banner.cross.black": "San Andresen gurutze beltza",
  "block.minecraft.banner.cross.blue": "San Andresen gurutze urdina",
  "block.minecraft.banner.cross.brown": "San Andresen gurutze marroia",
  "block.minecraft.banner.cross.cyan": "San Andresen gurutze ziana",
  "block.minecraft.banner.cross.gray": "San Andresen gurutze grisa",
  "block.minecraft.banner.cross.green": "San Andresen gurutze berdea",
  "block.minecraft.banner.cross.light_blue": "San Andresen gurutze urdin argia",
  "block.minecraft.banner.cross.light_gray": "San Andresen gurutze gris argia",
  "block.minecraft.banner.cross.lime": "San Andresen gurutze lima",
  "block.minecraft.banner.cross.magenta": "San Andresen gurutze magenta",
  "block.minecraft.banner.cross.orange": "San Andresen gurutze laranja",
  "block.minecraft.banner.cross.pink": "San Andresen gurutze arrosa",
  "block.minecraft.banner.cross.purple": "San Andresen gurutze morea",
  "block.minecraft.banner.cross.red": "San Andresen gurutze gorria",
  "block.minecraft.banner.cross.white": "San Andresen gurutze zuria",
  "block.minecraft.banner.cross.yellow": "San Andresen gurutze horia",
  "block.minecraft.banner.curly_border.black": "Koskadun ertz beltza",
  "block.minecraft.banner.curly_border.blue": "Koskadun ertz urdina",
  "block.minecraft.banner.curly_border.brown": "Koskadun ertz marroia",
  "block.minecraft.banner.curly_border.cyan": "Koskadun ertz ziana",
  "block.minecraft.banner.curly_border.gray": "Koskadun ertz grisa",
  "block.minecraft.banner.curly_border.green": "Koskadun ertz berdea",
  "block.minecraft.banner.curly_border.light_blue": "Koskadun ertz urdin argia",
  "block.minecraft.banner.curly_border.light_gray": "Koskadun ertz gris argia",
  "block.minecraft.banner.curly_border.lime": "Koskadun ertz lima",
  "block.minecraft.banner.curly_border.magenta": "Koskadun ertz magenta",
  "block.minecraft.banner.curly_border.orange": "Koskadun ertz laranja",
  "block.minecraft.banner.curly_border.pink": "Koskadun ertz arrosa",
  "block.minecraft.banner.curly_border.purple": "Koskadun ertz morea",
  "block.minecraft.banner.curly_border.red": "Koskadun ertz gorria",
  "block.minecraft.banner.curly_border.white": "Koskadun ertz zuria",
  "block.minecraft.banner.curly_border.yellow": "Koskadun ertz horia",
  "block.minecraft.banner.diagonal_left.black": "Ezkerreko banda beltz erdibitzailea",
  "block.minecraft.banner.diagonal_left.blue": "Ezkerreko banda urdin erdibitzailea",
  "block.minecraft.banner.diagonal_left.brown": "Ezkerreko banda marroi erdibitzailea",
  "block.minecraft.banner.diagonal_left.cyan": "Ezkerreko banda zian erdibitzailea",
  "block.minecraft.banner.diagonal_left.gray": "Ezkerreko banda gris erdibitzailea",
  "block.minecraft.banner.diagonal_left.green": "Ezkerreko banda berde erdibitzailea",
  "block.minecraft.banner.diagonal_left.light_blue": "Ezkerreko banda urdin argi erdibitzailea",
  "block.minecraft.banner.diagonal_left.light_gray": "Ezkerreko banda gris argi erdibitzailea",
  "block.minecraft.banner.diagonal_left.lime": "Ezkerreko banda lima erdibitzailea",
  "block.minecraft.banner.diagonal_left.magenta": "Ezkerreko banda magenta erdibitzailea",
  "block.minecraft.banner.diagonal_left.orange": "Ezkerreko banda laranja erdibitzailea",
  "block.minecraft.banner.diagonal_left.pink": "Ezkerreko banda arrosa erdibitzailea",
  "block.minecraft.banner.diagonal_left.purple": "Ezkerreko banda more erdibitzailea",
  "block.minecraft.banner.diagonal_left.red": "Ezkerreko banda gorri erdibitzailea",
  "block.minecraft.banner.diagonal_left.white": "Ezkerreko banda zuri erdibitzailea",
  "block.minecraft.banner.diagonal_left.yellow": "Ezkerreko banda hori erdibitzailea",
  "block.minecraft.banner.diagonal_right.black": "Eskuineko banda beltz erdibitzailea",
  "block.minecraft.banner.diagonal_right.blue": "Eskuineko banda urdin erdibitzailea",
  "block.minecraft.banner.diagonal_right.brown": "Eskuineko banda marroi erdibitzailea",
  "block.minecraft.banner.diagonal_right.cyan": "Eskuineko banda zian erdibitzailea",
  "block.minecraft.banner.diagonal_right.gray": "Eskuineko banda gris erdibitzailea",
  "block.minecraft.banner.diagonal_right.green": "Eskuineko banda berde erdibitzailea",
  "block.minecraft.banner.diagonal_right.light_blue": "Eskuineko banda urdin argi erdibitzailea",
  "block.minecraft.banner.diagonal_right.light_gray": "Eskuineko banda gris argi erdibitzailea",
  "block.minecraft.banner.diagonal_right.lime": "Eskuineko banda lima erdibitzailea",
  "block.minecraft.banner.diagonal_right.magenta": "Eskuineko banda magenta erdibitzailea",
  "block.minecraft.banner.diagonal_right.orange": "Eskuineko banda laranja erdibitzailea",
  "block.minecraft.banner.diagonal_right.pink": "Eskuineko banda arrosa erdibitzailea",
  "block.minecraft.banner.diagonal_right.purple": "Eskuineko banda morea erdibitzailea",
  "block.minecraft.banner.diagonal_right.red": "Eskuineko banda gorri erdibitzailea",
  "block.minecraft.banner.diagonal_right.white": "Eskuineko banda zuri erdibitzailea",
  "block.minecraft.banner.diagonal_right.yellow": "Eskuineko banda hori erdibitzailea",
  "block.minecraft.banner.diagonal_up_left.black": "Eskuineko banda beltz erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.blue": "Eskuineko banda urdin erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.brown": "Eskuineko banda marroi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.cyan": "Eskuineko banda zian erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.gray": "Eskuineko banda gris erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.green": "Eskuineko banda berde erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Eskuineko banda urdin argi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Eskuineko banda gris argi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.lime": "Eskuineko banda lima erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.magenta": "Eskuineko banda magenta erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.orange": "Eskuineko banda laranja erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.pink": "Eskuineko banda arrosa erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.purple": "Eskuineko banda more erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.red": "Eskuineko banda gorri erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.white": "Eskuineko banda zuri erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_left.yellow": "Eskuineko banda hori erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.black": "Ezkerreko banda beltz erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.blue": "Ezkerreko banda urdin erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.brown": "Ezkerreko banda marroi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.cyan": "Ezkerreko banda zian erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.gray": "Ezkerreko banda gris erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.green": "Ezkerreko banda berde erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ezkerreko banda urdin argi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ezkerreko banda gris argi erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.lime": "Ezkerreko banda lima erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ezkerreko banda magenta erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.orange": "Ezkerreko banda laranja erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.pink": "Ezkerreko banda arrosa erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.purple": "Ezkerreko banda more erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.red": "Ezkerreko banda gorri erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.white": "Ezkerreko banda zuri erdibitzaile alderantzikatua",
  "block.minecraft.banner.diagonal_up_right.yellow": "Ezkerreko banda hori erdibitzaile alderantzikatua",
  "block.minecraft.banner.flow.black": "Fluxu beltza",
  "block.minecraft.banner.flow.blue": "Fluxu urdina",
  "block.minecraft.banner.flow.brown": "Fluxu marroia",
  "block.minecraft.banner.flow.cyan": "Fluxu ziana",
  "block.minecraft.banner.flow.gray": "Fluxu grisa",
  "block.minecraft.banner.flow.green": "Fluxu berdea",
  "block.minecraft.banner.flow.light_blue": "Fluxu urdin argia",
  "block.minecraft.banner.flow.light_gray": "Fluxu gris argia",
  "block.minecraft.banner.flow.lime": "Fluxu lima",
  "block.minecraft.banner.flow.magenta": "Fluxu magenta",
  "block.minecraft.banner.flow.orange": "Fluxu laranja",
  "block.minecraft.banner.flow.pink": "Fluxu arrosa",
  "block.minecraft.banner.flow.purple": "Fluxu morea",
  "block.minecraft.banner.flow.red": "Fluxu gorria",
  "block.minecraft.banner.flow.white": "Fluxu zuria",
  "block.minecraft.banner.flow.yellow": "Fluxu horia",
  "block.minecraft.banner.flower.black": "Lore beltz kargatua",
  "block.minecraft.banner.flower.blue": "Lore urdin kargatua",
  "block.minecraft.banner.flower.brown": "Lore marroi kargatua",
  "block.minecraft.banner.flower.cyan": "Lore ziana kargatua",
  "block.minecraft.banner.flower.gray": "Lore gris kargatua",
  "block.minecraft.banner.flower.green": "Lore berde kargatua",
  "block.minecraft.banner.flower.light_blue": "Lore urdin argi kargatua",
  "block.minecraft.banner.flower.light_gray": "Lore gris argi kargatua",
  "block.minecraft.banner.flower.lime": "Lore lima kargatua",
  "block.minecraft.banner.flower.magenta": "Lore magenta kargatua",
  "block.minecraft.banner.flower.orange": "Lore laranja kargatua",
  "block.minecraft.banner.flower.pink": "Lore arrosa kargatua",
  "block.minecraft.banner.flower.purple": "Lore more kargatua",
  "block.minecraft.banner.flower.red": "Lore gorri kargatua",
  "block.minecraft.banner.flower.white": "Lore zuri kargatua",
  "block.minecraft.banner.flower.yellow": "Lore hori kargatua",
  "block.minecraft.banner.globe.black": "Planeta beltza",
  "block.minecraft.banner.globe.blue": "Planeta urdina",
  "block.minecraft.banner.globe.brown": "Planeta marroia",
  "block.minecraft.banner.globe.cyan": "Planeta ziana",
  "block.minecraft.banner.globe.gray": "Planeta grisa",
  "block.minecraft.banner.globe.green": "Planeta berdea",
  "block.minecraft.banner.globe.light_blue": "Planeta urdin argia",
  "block.minecraft.banner.globe.light_gray": "Planeta gris argia",
  "block.minecraft.banner.globe.lime": "Planeta lima",
  "block.minecraft.banner.globe.magenta": "Planeta magenta",
  "block.minecraft.banner.globe.orange": "Planeta naranja",
  "block.minecraft.banner.globe.pink": "Planeta arrosa",
  "block.minecraft.banner.globe.purple": "Planeta morea",
  "block.minecraft.banner.globe.red": "Planeta gorria",
  "block.minecraft.banner.globe.white": "Planeta zuria",
  "block.minecraft.banner.globe.yellow": "Planeta horia",
  "block.minecraft.banner.gradient.black": "Gradiente beltza",
  "block.minecraft.banner.gradient.blue": "Gradiente urdina",
  "block.minecraft.banner.gradient.brown": "Gradiente marroia",
  "block.minecraft.banner.gradient.cyan": "Gradiente ziana",
  "block.minecraft.banner.gradient.gray": "Gradiente grisa",
  "block.minecraft.banner.gradient.green": "Gradiente berdea",
  "block.minecraft.banner.gradient.light_blue": "Gradiente urdin argia",
  "block.minecraft.banner.gradient.light_gray": "Gradiente gris argia",
  "block.minecraft.banner.gradient.lime": "Gradiente lima",
  "block.minecraft.banner.gradient.magenta": "Gradiente magenta",
  "block.minecraft.banner.gradient.orange": "Gradiente laranja",
  "block.minecraft.banner.gradient.pink": "Gradiente arrosa",
  "block.minecraft.banner.gradient.purple": "Gradiente morea",
  "block.minecraft.banner.gradient.red": "Gradiente gorria",
  "block.minecraft.banner.gradient.white": "Gradiente zuria",
  "block.minecraft.banner.gradient.yellow": "Gradiente horia",
  "block.minecraft.banner.gradient_up.black": "Hondo beltz gradientea",
  "block.minecraft.banner.gradient_up.blue": "Hondo urdin gradientea",
  "block.minecraft.banner.gradient_up.brown": "Hondo marroi gradientea",
  "block.minecraft.banner.gradient_up.cyan": "Hondo zian gradientea",
  "block.minecraft.banner.gradient_up.gray": "Hondo gris gradientea",
  "block.minecraft.banner.gradient_up.green": "Hondo berde gradientea",
  "block.minecraft.banner.gradient_up.light_blue": "Hondo urdin argi gradientea",
  "block.minecraft.banner.gradient_up.light_gray": "Hondo gris argi gradientea",
  "block.minecraft.banner.gradient_up.lime": "Hondo lima gradientea",
  "block.minecraft.banner.gradient_up.magenta": "Hondo magenta gradientea",
  "block.minecraft.banner.gradient_up.orange": "Hondo laranja gradientea",
  "block.minecraft.banner.gradient_up.pink": "Hondo arrosa gradientea",
  "block.minecraft.banner.gradient_up.purple": "Hondo more gradientea",
  "block.minecraft.banner.gradient_up.red": "Hondo gorri gradientea",
  "block.minecraft.banner.gradient_up.white": "Hondo zuri gradientea",
  "block.minecraft.banner.gradient_up.yellow": "Hondo hori gradientea",
  "block.minecraft.banner.guster.black": "Haizete beltza",
  "block.minecraft.banner.guster.blue": "Haizete urdina",
  "block.minecraft.banner.guster.brown": "Haizete marroia",
  "block.minecraft.banner.guster.cyan": "Haizete ziana",
  "block.minecraft.banner.guster.gray": "Haizete grisa",
  "block.minecraft.banner.guster.green": "Haizete berdea",
  "block.minecraft.banner.guster.light_blue": "Haizete urdin argia",
  "block.minecraft.banner.guster.light_gray": "Haizete gris argia",
  "block.minecraft.banner.guster.lime": "Haizete lima",
  "block.minecraft.banner.guster.magenta": "Haizete magenta",
  "block.minecraft.banner.guster.orange": "Haizete laranja",
  "block.minecraft.banner.guster.pink": "Haizete arrosa",
  "block.minecraft.banner.guster.purple": "Haizete morea",
  "block.minecraft.banner.guster.red": "Haizete gorria",
  "block.minecraft.banner.guster.white": "Haizete zuria",
  "block.minecraft.banner.guster.yellow": "Haizete horia",
  "block.minecraft.banner.half_horizontal.black": "Ebakitzaile beltza zerrendan",
  "block.minecraft.banner.half_horizontal.blue": "Ebakitzaile urdina zerrendan",
  "block.minecraft.banner.half_horizontal.brown": "Ebakitzaile beltza zerrendan",
  "block.minecraft.banner.half_horizontal.cyan": "Ebakitzaile ziana zerrendan",
  "block.minecraft.banner.half_horizontal.gray": "Ebakitzaile grisa zerrendan",
  "block.minecraft.banner.half_horizontal.green": "Ebakitzaile berdea zerrendan",
  "block.minecraft.banner.half_horizontal.light_blue": "Ebakitzaile urdin argia zerrendan",
  "block.minecraft.banner.half_horizontal.light_gray": "Ebakitzaile gris argia zerrendan",
  "block.minecraft.banner.half_horizontal.lime": "Ebakitzaile lima zerrendan",
  "block.minecraft.banner.half_horizontal.magenta": "Ebakitzaile magenta zerrendan",
  "block.minecraft.banner.half_horizontal.orange": "Ebakitzaile laranja zerrendan",
  "block.minecraft.banner.half_horizontal.pink": "Ebakitzaile arrosa zerrendan",
  "block.minecraft.banner.half_horizontal.purple": "Ebakitzaile morea zerrendan",
  "block.minecraft.banner.half_horizontal.red": "Ebakitzaile gorria zerrendan",
  "block.minecraft.banner.half_horizontal.white": "Ebakitzaile zuria zerrendan",
  "block.minecraft.banner.half_horizontal.yellow": "Ebakitzaile horia zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.black": "Alderantzikatutako ebakitzaile beltza zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Alderantzikatutako ebakitzaile urdina zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Alderantzikatutako ebakitzaile marroia zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Alderantzikatutako ebakitzaile ziana zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Alderantzikatutako ebakitzaile grisa zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.green": "Alderantzikatutako ebakitzaile berdea zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Alderantzikatutako ebakitzaile urdin argia zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Alderantzikatutako ebakitzaile gris argia zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Alderantzikatutako ebakitzaile lima zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Alderantzikatutako ebakitzaile magenta zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Alderantzikatutako ebakitzaile laranja zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Alderantzikatutako ebakitzaile arrosa zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Alderantzikatutako ebakitzaile morea zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.red": "Alderantzikatutako ebakitzaile gorria zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.white": "Alderantzikatutako ebakitzaile zuria zerrendan",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Alderantzikatutako ebakitzaile horia zerrendan",
  "block.minecraft.banner.half_vertical.black": "Erdibitzaile beltza zerrendan",
  "block.minecraft.banner.half_vertical.blue": "Erdibitzaile urdina zerrendan",
  "block.minecraft.banner.half_vertical.brown": "Erdibitzaile marroia zerrendan",
  "block.minecraft.banner.half_vertical.cyan": "Erdibitzaile ziana zerrendan",
  "block.minecraft.banner.half_vertical.gray": "Erdibitzaile grisa zerrendan",
  "block.minecraft.banner.half_vertical.green": "Erdibitzaile berdea zerrendan",
  "block.minecraft.banner.half_vertical.light_blue": "Erdibitzaile urdin argia zerrendan",
  "block.minecraft.banner.half_vertical.light_gray": "Erdibitzaile gris argia zerrendan",
  "block.minecraft.banner.half_vertical.lime": "Erdibitzaile lima zerrendan",
  "block.minecraft.banner.half_vertical.magenta": "Erdibitzaile magenta zerrendan",
  "block.minecraft.banner.half_vertical.orange": "Erdibitzaile laranja zerrendan",
  "block.minecraft.banner.half_vertical.pink": "Erdibitzaile arrosa zerrendan",
  "block.minecraft.banner.half_vertical.purple": "Erdibitzaile morea zerrendan",
  "block.minecraft.banner.half_vertical.red": "Erdibitzaile gorria zerrendan",
  "block.minecraft.banner.half_vertical.white": "Erdibitzaile zuria zerrendan",
  "block.minecraft.banner.half_vertical.yellow": "Erdibitzaile horia zerrendan",
  "block.minecraft.banner.half_vertical_right.black": "Alderantzikatutako erdibitzaile beltza zerrendan",
  "block.minecraft.banner.half_vertical_right.blue": "Alderantzikatutako erdibitzaile urdina zerrendan",
  "block.minecraft.banner.half_vertical_right.brown": "Alderantzikatutako erdibitzaile marroia zerrendan",
  "block.minecraft.banner.half_vertical_right.cyan": "Alderantzikatutako erdibitzaile ziana zerrendan",
  "block.minecraft.banner.half_vertical_right.gray": "Alderantzikatutako erdibitzaile grisa zerrendan",
  "block.minecraft.banner.half_vertical_right.green": "Alderantzikatutako erdibitzaile berdea zerrendan",
  "block.minecraft.banner.half_vertical_right.light_blue": "Alderantzikatutako erdibitzaile urdin argia zerrendan",
  "block.minecraft.banner.half_vertical_right.light_gray": "Alderantzikatutako erdibitzaile gris argia zerrendan",
  "block.minecraft.banner.half_vertical_right.lime": "Alderantzikatutako erdibitzaile lima zerrendan",
  "block.minecraft.banner.half_vertical_right.magenta": "Alderantzikatutako erdibitzaile magenta zerrendan",
  "block.minecraft.banner.half_vertical_right.orange": "Alderantzikatutako erdibitzaile laranja zerrendan",
  "block.minecraft.banner.half_vertical_right.pink": "Alderantzikatutako erdibitzaile arrosa zerrendan",
  "block.minecraft.banner.half_vertical_right.purple": "Alderantzikatutako erdibitzaile morea zerrendan",
  "block.minecraft.banner.half_vertical_right.red": "Alderantzikatutako erdibitzaile gorria zerrendan",
  "block.minecraft.banner.half_vertical_right.white": "Alderantzikatutako erdibitzaile zuria zerrendan",
  "block.minecraft.banner.half_vertical_right.yellow": "Alderantzikatutako erdibitzaile horia zerrendan",
  "block.minecraft.banner.mojang.black": "Gauza beltza",
  "block.minecraft.banner.mojang.blue": "Gauza urdina",
  "block.minecraft.banner.mojang.brown": "Gauza marroia",
  "block.minecraft.banner.mojang.cyan": "Gauza ziana",
  "block.minecraft.banner.mojang.gray": "Gauza grisa",
  "block.minecraft.banner.mojang.green": "Gauza berdea",
  "block.minecraft.banner.mojang.light_blue": "Gauza urdin argia",
  "block.minecraft.banner.mojang.light_gray": "Gauza gris argia",
  "block.minecraft.banner.mojang.lime": "Gauza lima",
  "block.minecraft.banner.mojang.magenta": "Gauza magenta",
  "block.minecraft.banner.mojang.orange": "Gauza laranja",
  "block.minecraft.banner.mojang.pink": "Gauza arrosa",
  "block.minecraft.banner.mojang.purple": "Gauza morea",
  "block.minecraft.banner.mojang.red": "Gauza gorria",
  "block.minecraft.banner.mojang.white": "Gauza zuria",
  "block.minecraft.banner.mojang.yellow": "Gauza horia",
  "block.minecraft.banner.piglin.black": "Mutur beltza",
  "block.minecraft.banner.piglin.blue": "Mutur urdina",
  "block.minecraft.banner.piglin.brown": "Mutur marroia",
  "block.minecraft.banner.piglin.cyan": "Mutur ziana",
  "block.minecraft.banner.piglin.gray": "Mutur grisa",
  "block.minecraft.banner.piglin.green": "Mutur berdea",
  "block.minecraft.banner.piglin.light_blue": "Mutur urdin argia",
  "block.minecraft.banner.piglin.light_gray": "Mutur gris argia",
  "block.minecraft.banner.piglin.lime": "Mutur lima",
  "block.minecraft.banner.piglin.magenta": "Mutur magenta",
  "block.minecraft.banner.piglin.orange": "Mutur laranja",
  "block.minecraft.banner.piglin.pink": "Mutur arrosa",
  "block.minecraft.banner.piglin.purple": "Mutur morea",
  "block.minecraft.banner.piglin.red": "Mutur gorria",
  "block.minecraft.banner.piglin.white": "Mutur zuria",
  "block.minecraft.banner.piglin.yellow": "Mutur horia",
  "block.minecraft.banner.rhombus.black": "Erronbo beltza",
  "block.minecraft.banner.rhombus.blue": "Erronbo urdina",
  "block.minecraft.banner.rhombus.brown": "Erronbo marroia",
  "block.minecraft.banner.rhombus.cyan": "Erronbo ziana",
  "block.minecraft.banner.rhombus.gray": "Erronbo grisa",
  "block.minecraft.banner.rhombus.green": "Erronbo berdea",
  "block.minecraft.banner.rhombus.light_blue": "Erronbo urdin argia",
  "block.minecraft.banner.rhombus.light_gray": "Erronbo gris argia",
  "block.minecraft.banner.rhombus.lime": "Erronbo lima",
  "block.minecraft.banner.rhombus.magenta": "Erronbo magenta",
  "block.minecraft.banner.rhombus.orange": "Erronbo laranja",
  "block.minecraft.banner.rhombus.pink": "Erronbo arrosa",
  "block.minecraft.banner.rhombus.purple": "Erronbo morea",
  "block.minecraft.banner.rhombus.red": "Erronbo gorria",
  "block.minecraft.banner.rhombus.white": "Erronbo zuria",
  "block.minecraft.banner.rhombus.yellow": "Erronbo horia",
  "block.minecraft.banner.skull.black": "Garezur beltz kargatua",
  "block.minecraft.banner.skull.blue": "Garezur urdin kargatua",
  "block.minecraft.banner.skull.brown": "Garezur marroi kargatua",
  "block.minecraft.banner.skull.cyan": "Garezur zian kargatua",
  "block.minecraft.banner.skull.gray": "Garezur gris kargatua",
  "block.minecraft.banner.skull.green": "Garezur berde kargatua",
  "block.minecraft.banner.skull.light_blue": "Garezur urdin argi kargatua",
  "block.minecraft.banner.skull.light_gray": "Garezur gris argi kargatua",
  "block.minecraft.banner.skull.lime": "Garezur lima kargatua",
  "block.minecraft.banner.skull.magenta": "Garezur magenta kargatua",
  "block.minecraft.banner.skull.orange": "Garezur laranja kargatua",
  "block.minecraft.banner.skull.pink": "Garezur arrosa kargatua",
  "block.minecraft.banner.skull.purple": "Garezur more kargatua",
  "block.minecraft.banner.skull.red": "Garezur gorri kargatua",
  "block.minecraft.banner.skull.white": "Garezur zuri kargatua",
  "block.minecraft.banner.skull.yellow": "Garezur hori kargatua",
  "block.minecraft.banner.small_stripes.black": "Palatu beltza",
  "block.minecraft.banner.small_stripes.blue": "Palatu urdina",
  "block.minecraft.banner.small_stripes.brown": "Palatu marroia",
  "block.minecraft.banner.small_stripes.cyan": "Palatu ziana",
  "block.minecraft.banner.small_stripes.gray": "Palatu grisa",
  "block.minecraft.banner.small_stripes.green": "Palatu berdea",
  "block.minecraft.banner.small_stripes.light_blue": "Palatu urdin argia",
  "block.minecraft.banner.small_stripes.light_gray": "Palatu gris argia",
  "block.minecraft.banner.small_stripes.lime": "Palatu lima",
  "block.minecraft.banner.small_stripes.magenta": "Palatu magenta",
  "block.minecraft.banner.small_stripes.orange": "Palatu laranja",
  "block.minecraft.banner.small_stripes.pink": "Palatu arrosa",
  "block.minecraft.banner.small_stripes.purple": "Palatu morea",
  "block.minecraft.banner.small_stripes.red": "Palatu gorria",
  "block.minecraft.banner.small_stripes.white": "Palatu zuria",
  "block.minecraft.banner.small_stripes.yellow": "Palatu horia",
  "block.minecraft.banner.square_bottom_left.black": "Behe eskuineko kantoi beltza",
  "block.minecraft.banner.square_bottom_left.blue": "Behe eskuineko kantoi urdina",
  "block.minecraft.banner.square_bottom_left.brown": "Behe eskuineko kantoi marroia",
  "block.minecraft.banner.square_bottom_left.cyan": "Behe eskuineko kantoi ziana",
  "block.minecraft.banner.square_bottom_left.gray": "Behe eskuineko kantoi grisa",
  "block.minecraft.banner.square_bottom_left.green": "Behe eskuineko kantoi berdea",
  "block.minecraft.banner.square_bottom_left.light_blue": "Behe eskuineko kantoi urdin argia",
  "block.minecraft.banner.square_bottom_left.light_gray": "Behe eskuineko kantoi gris argia",
  "block.minecraft.banner.square_bottom_left.lime": "Behe eskuineko kantoi lima",
  "block.minecraft.banner.square_bottom_left.magenta": "Behe eskuineko kantoi magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Behe eskuineko kantoi laranja",
  "block.minecraft.banner.square_bottom_left.pink": "Behe eskuineko kantoi arrosa",
  "block.minecraft.banner.square_bottom_left.purple": "Behe eskuineko kantoi morea",
  "block.minecraft.banner.square_bottom_left.red": "Behe eskuineko kantoi gorria",
  "block.minecraft.banner.square_bottom_left.white": "Behe eskuineko kantoi zuria",
  "block.minecraft.banner.square_bottom_left.yellow": "Behe eskuineko kantoi horia",
  "block.minecraft.banner.square_bottom_right.black": "Behe ezkerreko kantoi beltza",
  "block.minecraft.banner.square_bottom_right.blue": "Behe ezkerreko kantoi beltza",
  "block.minecraft.banner.square_bottom_right.brown": "Behe ezkerreko kantoi marroia",
  "block.minecraft.banner.square_bottom_right.cyan": "Behe ezkerreko kantoi ziana",
  "block.minecraft.banner.square_bottom_right.gray": "Behe ezkerreko kantoi grisa",
  "block.minecraft.banner.square_bottom_right.green": "Behe ezkerreko kantoi berdea",
  "block.minecraft.banner.square_bottom_right.light_blue": "Behe ezkerreko kantoi urdin argia",
  "block.minecraft.banner.square_bottom_right.light_gray": "Behe ezkerreko kantoi gris argia",
  "block.minecraft.banner.square_bottom_right.lime": "Behe ezkerreko kantoi lima",
  "block.minecraft.banner.square_bottom_right.magenta": "Behe ezkerreko kantoi magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Behe ezkerreko kantoi laranja",
  "block.minecraft.banner.square_bottom_right.pink": "Behe ezkerreko kantoi arrosa",
  "block.minecraft.banner.square_bottom_right.purple": "Behe ezkerreko kantoi morea",
  "block.minecraft.banner.square_bottom_right.red": "Behe ezkerreko kantoi gorria",
  "block.minecraft.banner.square_bottom_right.white": "Behe ezkerreko kantoi zuria",
  "block.minecraft.banner.square_bottom_right.yellow": "Behe ezkerreko kantoi horia",
  "block.minecraft.banner.square_top_left.black": "Goi eskuineko kantoi beltza",
  "block.minecraft.banner.square_top_left.blue": "Goi eskuineko kantoi urdina",
  "block.minecraft.banner.square_top_left.brown": "Goi eskuineko kantoi marroia",
  "block.minecraft.banner.square_top_left.cyan": "Goi eskuineko kantoi ziana",
  "block.minecraft.banner.square_top_left.gray": "Goi eskuineko kantoi grisa",
  "block.minecraft.banner.square_top_left.green": "Goi eskuineko kantoi berdea",
  "block.minecraft.banner.square_top_left.light_blue": "Goi eskuineko kantoi urdin argia",
  "block.minecraft.banner.square_top_left.light_gray": "Goi eskuineko kantoi gris argia",
  "block.minecraft.banner.square_top_left.lime": "Goi eskuineko kantoi lima",
  "block.minecraft.banner.square_top_left.magenta": "Goi eskuineko kantoi magenta",
  "block.minecraft.banner.square_top_left.orange": "Goi eskuineko kantoi laranja",
  "block.minecraft.banner.square_top_left.pink": "Goi eskuineko kantoi arrosa",
  "block.minecraft.banner.square_top_left.purple": "Goi eskuineko kantoi morea",
  "block.minecraft.banner.square_top_left.red": "Goi eskuineko kantoi gorria",
  "block.minecraft.banner.square_top_left.white": "Goi eskuineko kantoi zuria",
  "block.minecraft.banner.square_top_left.yellow": "Goi eskuineko kantoi horia",
  "block.minecraft.banner.square_top_right.black": "Goi ezkerreko kantoi beltza",
  "block.minecraft.banner.square_top_right.blue": "Goi ezkerreko kantoi urdina",
  "block.minecraft.banner.square_top_right.brown": "Goi ezkerreko kantoi marroia",
  "block.minecraft.banner.square_top_right.cyan": "Goi ezkerreko kantoi ziana",
  "block.minecraft.banner.square_top_right.gray": "Goi ezkerreko kantoi grisa",
  "block.minecraft.banner.square_top_right.green": "Goi ezkerreko kantoi berdea",
  "block.minecraft.banner.square_top_right.light_blue": "Goi ezkerreko kantoi urdin argia",
  "block.minecraft.banner.square_top_right.light_gray": "Goi ezkerreko kantoi gris argia",
  "block.minecraft.banner.square_top_right.lime": "Goi ezkerreko kantoi lima",
  "block.minecraft.banner.square_top_right.magenta": "Goi ezkerreko kantoi magenta",
  "block.minecraft.banner.square_top_right.orange": "Goi ezkerreko kantoi laranja",
  "block.minecraft.banner.square_top_right.pink": "Goi ezkerreko kantoi arrosa",
  "block.minecraft.banner.square_top_right.purple": "Goi ezkerreko kantoi morea",
  "block.minecraft.banner.square_top_right.red": "Goi ezkerreko kantoi gorria",
  "block.minecraft.banner.square_top_right.white": "Goi ezkerreko kantoi zuria",
  "block.minecraft.banner.square_top_right.yellow": "Goi ezkerreko kantoi horia",
  "block.minecraft.banner.straight_cross.black": "Gurutze beltza",
  "block.minecraft.banner.straight_cross.blue": "Gurutze urdina",
  "block.minecraft.banner.straight_cross.brown": "Gurutze marroia",
  "block.minecraft.banner.straight_cross.cyan": "Gurutze ziana",
  "block.minecraft.banner.straight_cross.gray": "Gurutze grisa",
  "block.minecraft.banner.straight_cross.green": "Gurutze berdea",
  "block.minecraft.banner.straight_cross.light_blue": "Gurutze urdin argia",
  "block.minecraft.banner.straight_cross.light_gray": "Gurutze gris argia",
  "block.minecraft.banner.straight_cross.lime": "Gurutze lima",
  "block.minecraft.banner.straight_cross.magenta": "Gurutze magenta",
  "block.minecraft.banner.straight_cross.orange": "Gurutze laranja",
  "block.minecraft.banner.straight_cross.pink": "Gurutze arrosa",
  "block.minecraft.banner.straight_cross.purple": "Gurutze morea",
  "block.minecraft.banner.straight_cross.red": "Gurutze gorria",
  "block.minecraft.banner.straight_cross.white": "Gurutze zuria",
  "block.minecraft.banner.straight_cross.yellow": "Gurutze horia",
  "block.minecraft.banner.stripe_bottom.black": "Kanpaina beltza",
  "block.minecraft.banner.stripe_bottom.blue": "Kanpaina urdina",
  "block.minecraft.banner.stripe_bottom.brown": "Kanpaina marroia",
  "block.minecraft.banner.stripe_bottom.cyan": "Kanpaina ziana",
  "block.minecraft.banner.stripe_bottom.gray": "Kanpaina grisa",
  "block.minecraft.banner.stripe_bottom.green": "Kanpaina berdea",
  "block.minecraft.banner.stripe_bottom.light_blue": "Kanpaina urdin argia",
  "block.minecraft.banner.stripe_bottom.light_gray": "Kanpaina gris argia",
  "block.minecraft.banner.stripe_bottom.lime": "Kanpaina lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Kanpaina magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Kanpaina laranja",
  "block.minecraft.banner.stripe_bottom.pink": "Kanpaina arrosa",
  "block.minecraft.banner.stripe_bottom.purple": "Kanpaina morea",
  "block.minecraft.banner.stripe_bottom.red": "Kanpaina gorria",
  "block.minecraft.banner.stripe_bottom.white": "Kanpaina zuria",
  "block.minecraft.banner.stripe_bottom.yellow": "Kanpaina horia",
  "block.minecraft.banner.stripe_center.black": "Palu beltza",
  "block.minecraft.banner.stripe_center.blue": "Palu urdina",
  "block.minecraft.banner.stripe_center.brown": "Palu marroia",
  "block.minecraft.banner.stripe_center.cyan": "Palu ziana",
  "block.minecraft.banner.stripe_center.gray": "Palu grisa",
  "block.minecraft.banner.stripe_center.green": "Palu berdea",
  "block.minecraft.banner.stripe_center.light_blue": "Palu urdin argia",
  "block.minecraft.banner.stripe_center.light_gray": "Palu gris argia",
  "block.minecraft.banner.stripe_center.lime": "Palu lima",
  "block.minecraft.banner.stripe_center.magenta": "Palu magenta",
  "block.minecraft.banner.stripe_center.orange": "Palu laranja",
  "block.minecraft.banner.stripe_center.pink": "Palu arrosa",
  "block.minecraft.banner.stripe_center.purple": "Palu morea",
  "block.minecraft.banner.stripe_center.red": "Palu gorria",
  "block.minecraft.banner.stripe_center.white": "Palu zuria",
  "block.minecraft.banner.stripe_center.yellow": "Palu horia",
  "block.minecraft.banner.stripe_downleft.black": "Ezkerreko banda beltza",
  "block.minecraft.banner.stripe_downleft.blue": "Ezkerreko banda urdina",
  "block.minecraft.banner.stripe_downleft.brown": "Ezkerreko banda marroia",
  "block.minecraft.banner.stripe_downleft.cyan": "Ezkerreko banda ziana",
  "block.minecraft.banner.stripe_downleft.gray": "Ezkerreko banda grisa",
  "block.minecraft.banner.stripe_downleft.green": "Ezkerreko banda berdea",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ezkerreko banda urdin argia",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ezkerreko banda gris argia",
  "block.minecraft.banner.stripe_downleft.lime": "Ezkerreko banda lima",
  "block.minecraft.banner.stripe_downleft.magenta": "Ezkerreko banda magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Ezkerreko banda laranja",
  "block.minecraft.banner.stripe_downleft.pink": "Ezkerreko banda arrosa",
  "block.minecraft.banner.stripe_downleft.purple": "Ezkerreko banda morea",
  "block.minecraft.banner.stripe_downleft.red": "Ezkerreko banda gorria",
  "block.minecraft.banner.stripe_downleft.white": "Ezkerreko banda zuria",
  "block.minecraft.banner.stripe_downleft.yellow": "Ezkerreko banda horia",
  "block.minecraft.banner.stripe_downright.black": "Eskuineko banda beltza",
  "block.minecraft.banner.stripe_downright.blue": "Eskuineko banda urdina",
  "block.minecraft.banner.stripe_downright.brown": "Eskuineko banda marroia",
  "block.minecraft.banner.stripe_downright.cyan": "Eskuineko banda ziana",
  "block.minecraft.banner.stripe_downright.gray": "Eskuineko banda grisa",
  "block.minecraft.banner.stripe_downright.green": "Eskuineko banda berdea",
  "block.minecraft.banner.stripe_downright.light_blue": "Eskuineko banda urdin argia",
  "block.minecraft.banner.stripe_downright.light_gray": "Eskuineko banda gris argia",
  "block.minecraft.banner.stripe_downright.lime": "Eskuineko banda lima",
  "block.minecraft.banner.stripe_downright.magenta": "Eskuineko banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Eskuineko banda laranja",
  "block.minecraft.banner.stripe_downright.pink": "Eskuineko banda arrosa",
  "block.minecraft.banner.stripe_downright.purple": "Eskuineko banda morea",
  "block.minecraft.banner.stripe_downright.red": "Eskuineko banda gorria",
  "block.minecraft.banner.stripe_downright.white": "Eskuineko banda zuria",
  "block.minecraft.banner.stripe_downright.yellow": "Eskuineko banda horia",
  "block.minecraft.banner.stripe_left.black": "Eskuineko palu beltza",
  "block.minecraft.banner.stripe_left.blue": "Eskuineko palu urdina",
  "block.minecraft.banner.stripe_left.brown": "Eskuineko palu marroia",
  "block.minecraft.banner.stripe_left.cyan": "Eskuineko palu ziana",
  "block.minecraft.banner.stripe_left.gray": "Eskuineko palu grisa",
  "block.minecraft.banner.stripe_left.green": "Eskuineko palu berdea",
  "block.minecraft.banner.stripe_left.light_blue": "Eskuineko palu urdin argia",
  "block.minecraft.banner.stripe_left.light_gray": "Eskuineko palu gris argia",
  "block.minecraft.banner.stripe_left.lime": "Eskuineko palu lima",
  "block.minecraft.banner.stripe_left.magenta": "Eskuineko palu magenta",
  "block.minecraft.banner.stripe_left.orange": "Eskuineko palu laranja",
  "block.minecraft.banner.stripe_left.pink": "Eskuineko palu arrosa",
  "block.minecraft.banner.stripe_left.purple": "Eskuineko palu morea",
  "block.minecraft.banner.stripe_left.red": "Eskuineko palu gorria",
  "block.minecraft.banner.stripe_left.white": "Eskuineko palu zuria",
  "block.minecraft.banner.stripe_left.yellow": "Eskuineko palu horia",
  "block.minecraft.banner.stripe_middle.black": "Zerrenda beltza",
  "block.minecraft.banner.stripe_middle.blue": "Zerrenda urdina",
  "block.minecraft.banner.stripe_middle.brown": "Zerrenda marroia",
  "block.minecraft.banner.stripe_middle.cyan": "Zerrenda ziana",
  "block.minecraft.banner.stripe_middle.gray": "Zerrenda grisa",
  "block.minecraft.banner.stripe_middle.green": "Zerrenda berdea",
  "block.minecraft.banner.stripe_middle.light_blue": "Zerrenda urdin argia",
  "block.minecraft.banner.stripe_middle.light_gray": "Zerrenda gris argia",
  "block.minecraft.banner.stripe_middle.lime": "Zerrenda lima",
  "block.minecraft.banner.stripe_middle.magenta": "Zerrenda magenta",
  "block.minecraft.banner.stripe_middle.orange": "Zerrenda laranja",
  "block.minecraft.banner.stripe_middle.pink": "Zerrenda arrosa",
  "block.minecraft.banner.stripe_middle.purple": "Zerrenda morea",
  "block.minecraft.banner.stripe_middle.red": "Zerrenda gorria",
  "block.minecraft.banner.stripe_middle.white": "Zerrenda zuria",
  "block.minecraft.banner.stripe_middle.yellow": "Zerrenda horia",
  "block.minecraft.banner.stripe_right.black": "Ezkerreko palu beltza",
  "block.minecraft.banner.stripe_right.blue": "Ezkerreko palu urdina",
  "block.minecraft.banner.stripe_right.brown": "Ezkerreko palu marroia",
  "block.minecraft.banner.stripe_right.cyan": "Ezkerreko palu ziana",
  "block.minecraft.banner.stripe_right.gray": "Ezkerreko palu grisa",
  "block.minecraft.banner.stripe_right.green": "Ezkerreko palu berdea",
  "block.minecraft.banner.stripe_right.light_blue": "Ezkerreko palu urdin argia",
  "block.minecraft.banner.stripe_right.light_gray": "Ezkerreko palu gris argia",
  "block.minecraft.banner.stripe_right.lime": "Ezkerreko palu lima",
  "block.minecraft.banner.stripe_right.magenta": "Ezkerreko palu magenta",
  "block.minecraft.banner.stripe_right.orange": "Ezkerreko palu laranja",
  "block.minecraft.banner.stripe_right.pink": "Ezkerreko palu arrosa",
  "block.minecraft.banner.stripe_right.purple": "Ezkerreko palu morea",
  "block.minecraft.banner.stripe_right.red": "Ezkerreko palu gorria",
  "block.minecraft.banner.stripe_right.white": "Ezkerreko palu zuria",
  "block.minecraft.banner.stripe_right.yellow": "Ezkerreko palu horia",
  "block.minecraft.banner.stripe_top.black": "Buru beltza",
  "block.minecraft.banner.stripe_top.blue": "Buru urdina",
  "block.minecraft.banner.stripe_top.brown": "Buru marroia",
  "block.minecraft.banner.stripe_top.cyan": "Buru ziana",
  "block.minecraft.banner.stripe_top.gray": "Buru grisa",
  "block.minecraft.banner.stripe_top.green": "Buru berdea",
  "block.minecraft.banner.stripe_top.light_blue": "Buru urdin argia",
  "block.minecraft.banner.stripe_top.light_gray": "Buru gris argia",
  "block.minecraft.banner.stripe_top.lime": "Buru lima",
  "block.minecraft.banner.stripe_top.magenta": "Buru magenta",
  "block.minecraft.banner.stripe_top.orange": "Buru laranja",
  "block.minecraft.banner.stripe_top.pink": "Buru arrosa",
  "block.minecraft.banner.stripe_top.purple": "Buru morea",
  "block.minecraft.banner.stripe_top.red": "Buru gorria",
  "block.minecraft.banner.stripe_top.white": "Buru zuria",
  "block.minecraft.banner.stripe_top.yellow": "Buru horia",
  "block.minecraft.banner.triangle_bottom.black": "Gapirio beltza",
  "block.minecraft.banner.triangle_bottom.blue": "Gapirio urdina",
  "block.minecraft.banner.triangle_bottom.brown": "Gapirio marroia",
  "block.minecraft.banner.triangle_bottom.cyan": "Gapirio ziana",
  "block.minecraft.banner.triangle_bottom.gray": "Gapirio grisa",
  "block.minecraft.banner.triangle_bottom.green": "Gapirio berdea",
  "block.minecraft.banner.triangle_bottom.light_blue": "Gapirio urdin argia",
  "block.minecraft.banner.triangle_bottom.light_gray": "Gapirio gris argia",
  "block.minecraft.banner.triangle_bottom.lime": "Gapirio lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Gapirio magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Gapirio laranja",
  "block.minecraft.banner.triangle_bottom.pink": "Gapirio arrosa",
  "block.minecraft.banner.triangle_bottom.purple": "Gapirio morea",
  "block.minecraft.banner.triangle_bottom.red": "Gapirio gorria",
  "block.minecraft.banner.triangle_bottom.white": "Gapirio zuria",
  "block.minecraft.banner.triangle_bottom.yellow": "Gapirio horia",
  "block.minecraft.banner.triangle_top.black": "Gapirio beltz alderantzikatua",
  "block.minecraft.banner.triangle_top.blue": "Gapirio urdin alderantzikatua",
  "block.minecraft.banner.triangle_top.brown": "Gapirio marroia alderantzikatua",
  "block.minecraft.banner.triangle_top.cyan": "Gapirio ziana alderantzikatua",
  "block.minecraft.banner.triangle_top.gray": "Gapirio gris alderantzikatua",
  "block.minecraft.banner.triangle_top.green": "Gapirio berde alderantzikatua",
  "block.minecraft.banner.triangle_top.light_blue": "Gapirio urdin argi alderantzikatua",
  "block.minecraft.banner.triangle_top.light_gray": "Gapirio gris argi alderantzikatua",
  "block.minecraft.banner.triangle_top.lime": "Gapirio lima alderantzikatua",
  "block.minecraft.banner.triangle_top.magenta": "Gapirio magenta alderantzikatua",
  "block.minecraft.banner.triangle_top.orange": "Gapirio laranja alderantzikatua",
  "block.minecraft.banner.triangle_top.pink": "Gapirio arrosa alderantzikatua",
  "block.minecraft.banner.triangle_top.purple": "Gapirio more alderantzikatua",
  "block.minecraft.banner.triangle_top.red": "Gapirio gorri alderantzikatua",
  "block.minecraft.banner.triangle_top.white": "Gapirio zuri alderantzikatua",
  "block.minecraft.banner.triangle_top.yellow": "Gapirio hori alderantzikatua",
  "block.minecraft.banner.triangles_bottom.black": "Koskadun kanpaina beltza",
  "block.minecraft.banner.triangles_bottom.blue": "Koskadun kanpaina urdina",
  "block.minecraft.banner.triangles_bottom.brown": "Koskadun kanpaina marroia",
  "block.minecraft.banner.triangles_bottom.cyan": "Koskadun kanpaina ziana",
  "block.minecraft.banner.triangles_bottom.gray": "Koskadun kanpaina grisa",
  "block.minecraft.banner.triangles_bottom.green": "Koskadun kanpaina berdea",
  "block.minecraft.banner.triangles_bottom.light_blue": "Koskadun kanpaina urdin argia",
  "block.minecraft.banner.triangles_bottom.light_gray": "Koskadun kanpaina gris argia",
  "block.minecraft.banner.triangles_bottom.lime": "Koskadun kanpaina lima",
  "block.minecraft.banner.triangles_bottom.magenta": "Koskadun kanpaina magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Koskadun kanpaina laranja",
  "block.minecraft.banner.triangles_bottom.pink": "Koskadun kanpaina arrosa",
  "block.minecraft.banner.triangles_bottom.purple": "Koskadun kanpaina morea",
  "block.minecraft.banner.triangles_bottom.red": "Koskadun kanpaina gorria",
  "block.minecraft.banner.triangles_bottom.white": "Koskadun kanpaina zuria",
  "block.minecraft.banner.triangles_bottom.yellow": "Koskadun kanpaina horia",
  "block.minecraft.banner.triangles_top.black": "Koskadun buru beltza",
  "block.minecraft.banner.triangles_top.blue": "Koskadun buru urdina",
  "block.minecraft.banner.triangles_top.brown": "Koskadun buru marroia",
  "block.minecraft.banner.triangles_top.cyan": "Koskadun buru ziana",
  "block.minecraft.banner.triangles_top.gray": "Koskadun buru grisa",
  "block.minecraft.banner.triangles_top.green": "Koskadun buru berdea",
  "block.minecraft.banner.triangles_top.light_blue": "Koskadun buru urdin argia",
  "block.minecraft.banner.triangles_top.light_gray": "Koskadun buru gris argia",
  "block.minecraft.banner.triangles_top.lime": "Koskadun buru lima",
  "block.minecraft.banner.triangles_top.magenta": "Koskadun buru magenta",
  "block.minecraft.banner.triangles_top.orange": "Koskadun buru laranja",
  "block.minecraft.banner.triangles_top.pink": "Koskadun buru arrosa",
  "block.minecraft.banner.triangles_top.purple": "Koskadun buru morea",
  "block.minecraft.banner.triangles_top.red": "Koskadun buru gorria",
  "block.minecraft.banner.triangles_top.white": "Koskadun buru zuria",
  "block.minecraft.banner.triangles_top.yellow": "Koskadun buru horia",
  "block.minecraft.barrel": "Barrika",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basaltoa",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Botere nagusia",
  "block.minecraft.beacon.secondary": "Botere sekundarioa",
  "block.minecraft.bed.no_sleep": "Gauez edo ekaitz elektrikoetan bakarrik egin dezakezu lo",
  "block.minecraft.bed.not_safe": "Ezin duzu orain atseden hartu, munstroak hurbil dabiltza",
  "block.minecraft.bed.obstructed": "Ohe hau oztopatuta dago",
  "block.minecraft.bed.occupied": "Ohe hau okupaturik dago",
  "block.minecraft.bed.too_far_away": "Agian ez duzu atseden hartuko; ohea urrunegi dago",
  "block.minecraft.bedrock": "Arroka-mantua",
  "block.minecraft.bee_nest": "Erle habia",
  "block.minecraft.beehive": "Erlauntza",
  "block.minecraft.beetroots": "Erremolatxak",
  "block.minecraft.bell": "Kanpaia",
  "block.minecraft.big_dripleaf": "Tanta-hosto handia",
  "block.minecraft.big_dripleaf_stem": "Tanta-hosto zurtoin handia",
  "block.minecraft.birch_button": "Urkizko botoia",
  "block.minecraft.birch_door": "Urkizko atea",
  "block.minecraft.birch_fence": "Urkizko hesia",
  "block.minecraft.birch_fence_gate": "Urkizko hesi atea",
  "block.minecraft.birch_hanging_sign": "Izeizko kartel eskegia",
  "block.minecraft.birch_leaves": "Urki hostoak",
  "block.minecraft.birch_log": "Urki enborra",
  "block.minecraft.birch_planks": "Urki oholak",
  "block.minecraft.birch_pressure_plate": "Urkizko presio plaka",
  "block.minecraft.birch_sapling": "Urki kimua",
  "block.minecraft.birch_shelf": "Urkizko apala",
  "block.minecraft.birch_sign": "Urkizko kartela",
  "block.minecraft.birch_slab": "Urkizko lauza",
  "block.minecraft.birch_stairs": "Urkizko eskailerak",
  "block.minecraft.birch_trapdoor": "Urkizko tranpola",
  "block.minecraft.birch_wall_hanging_sign": "Izeizko kartel eskegia horman",
  "block.minecraft.birch_wall_sign": "Urki kartela horman",
  "block.minecraft.birch_wood": "Urki egurra",
  "block.minecraft.black_banner": "Zutoihal beltza",
  "block.minecraft.black_bed": "Ohe Beltza",
  "block.minecraft.black_candle": "Kandela beltza",
  "block.minecraft.black_candle_cake": "Tarta kandela beltzarekin",
  "block.minecraft.black_carpet": "Beltz koloreko alfonbra",
  "block.minecraft.black_concrete": "Hormigoi Beltza",
  "block.minecraft.black_concrete_powder": "Zementu beltza",
  "block.minecraft.black_glazed_terracotta": "Terrakota beiraztatu beltza",
  "block.minecraft.black_shulker_box": "Shulker-kutxa beltza",
  "block.minecraft.black_stained_glass": "Kristal beltza",
  "block.minecraft.black_stained_glass_pane": "Kristalezko panel beltza",
  "block.minecraft.black_terracotta": "Terrakota beltza",
  "block.minecraft.black_wool": "Artile beltza",
  "block.minecraft.blackstone": "Harribeltza",
  "block.minecraft.blackstone_slab": "Harribeltzezko lauza",
  "block.minecraft.blackstone_stairs": "Harribeltzezko eskailerak",
  "block.minecraft.blackstone_wall": "Harribeltzezko horma",
  "block.minecraft.blast_furnace": "Labe garaia",
  "block.minecraft.blue_banner": "Zutoihal urdina",
  "block.minecraft.blue_bed": "Ohe Urdina",
  "block.minecraft.blue_candle": "Kandela urdina",
  "block.minecraft.blue_candle_cake": "Tarta kandela urdinarekin",
  "block.minecraft.blue_carpet": "Urdin koloreko alfonbra",
  "block.minecraft.blue_concrete": "Hormigoi Urdina",
  "block.minecraft.blue_concrete_powder": "Zementu urdina",
  "block.minecraft.blue_glazed_terracotta": "Terrakota beiraztatu urdina",
  "block.minecraft.blue_ice": "Izotz urdina",
  "block.minecraft.blue_orchid": "Orkide urdina",
  "block.minecraft.blue_shulker_box": "Shulker-kutxa urdina",
  "block.minecraft.blue_stained_glass": "Kristal urdina",
  "block.minecraft.blue_stained_glass_pane": "Kristalezko panel urdina",
  "block.minecraft.blue_terracotta": "Terrakota urdina",
  "block.minecraft.blue_wool": "Artile urdina",
  "block.minecraft.bone_block": "Hezur Blokea",
  "block.minecraft.bookshelf": "Liburu-apalategia",
  "block.minecraft.brain_coral": "Burmuin korala",
  "block.minecraft.brain_coral_block": "Bizigabeko burmuin koral blokea",
  "block.minecraft.brain_coral_fan": "Burmuin korala",
  "block.minecraft.brain_coral_wall_fan": "Brain Coral Hormako Fan",
  "block.minecraft.brewing_stand": "Edabe-mahaia",
  "block.minecraft.brick_slab": "Adreiluzko lauza",
  "block.minecraft.brick_stairs": "Adreiluzko eskailerak",
  "block.minecraft.brick_wall": "Adreiluzko horma",
  "block.minecraft.bricks": "Adreiluak",
  "block.minecraft.brown_banner": "Zutoihal marroia",
  "block.minecraft.brown_bed": "Ohe Marroia",
  "block.minecraft.brown_candle": "Kandela marroia",
  "block.minecraft.brown_candle_cake": "Tarta kandela marroiarekin",
  "block.minecraft.brown_carpet": "Marroi koloreko alfonbra",
  "block.minecraft.brown_concrete": "Hormigoi Marroia",
  "block.minecraft.brown_concrete_powder": "Zementu marroia",
  "block.minecraft.brown_glazed_terracotta": "Terrakota beiraztatu marroia",
  "block.minecraft.brown_mushroom": "Perretxiko marroia",
  "block.minecraft.brown_mushroom_block": "Perretxiko marroizko blokea",
  "block.minecraft.brown_shulker_box": "Shulker-kutxa marroia",
  "block.minecraft.brown_stained_glass": "Kristal marroia",
  "block.minecraft.brown_stained_glass_pane": "Kristalezko panel marroia",
  "block.minecraft.brown_terracotta": "Terrakota marroia",
  "block.minecraft.brown_wool": "Artile marroia",
  "block.minecraft.bubble_column": "Burbuila zutabea",
  "block.minecraft.bubble_coral": "Hodizko korala",
  "block.minecraft.bubble_coral_block": "Bizigabeko burbuila koral blokea",
  "block.minecraft.bubble_coral_fan": "Hodizko korala",
  "block.minecraft.bubble_coral_wall_fan": "Bubble Coral Wall Fan",
  "block.minecraft.budding_amethyst": "Ametista ernamuinltzailea",
  "block.minecraft.bush": "Zuhaixka",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktus lorea",
  "block.minecraft.cake": "Tarta",
  "block.minecraft.calcite": "Kaltzita",
  "block.minecraft.calibrated_sculk_sensor": "Sculk sentsore kalibratuta",
  "block.minecraft.campfire": "Sutegia",
  "block.minecraft.candle": "Kandela",
  "block.minecraft.candle_cake": "Tarta kandelarekin",
  "block.minecraft.carrots": "Azenarioak",
  "block.minecraft.cartography_table": "Kartografia-mahaia",
  "block.minecraft.carved_pumpkin": "Kalabaza tailatua",
  "block.minecraft.cauldron": "Galdara",
  "block.minecraft.cave_air": "Leize airea",
  "block.minecraft.cave_vines": "Leize Huntza",
  "block.minecraft.cave_vines_plant": "Leize Huntz Landarea",
  "block.minecraft.chain": "Burdinazko katea",
  "block.minecraft.chain_command_block": "Kate-komando blokea",
  "block.minecraft.cherry_button": "Gereziondozko botoia",
  "block.minecraft.cherry_door": "Gereziondozko atea",
  "block.minecraft.cherry_fence": "Gereziondozko hesia",
  "block.minecraft.cherry_fence_gate": "Gereziondozko hesi atea",
  "block.minecraft.cherry_hanging_sign": "Gereziondozko kartel eskekia",
  "block.minecraft.cherry_leaves": "Gereziondo hostoak",
  "block.minecraft.cherry_log": "Gereziondo enborra",
  "block.minecraft.cherry_planks": "Gereziondozko oholak",
  "block.minecraft.cherry_pressure_plate": "Gereziondozko presio plaka",
  "block.minecraft.cherry_sapling": "Gereziondo kimua",
  "block.minecraft.cherry_shelf": "Gereziondozko apala",
  "block.minecraft.cherry_sign": "Gereziondozko kartela",
  "block.minecraft.cherry_slab": "Gereziondozko lauza",
  "block.minecraft.cherry_stairs": "Gereziondozko eskailerak",
  "block.minecraft.cherry_trapdoor": "Gereziondozko tranpola",
  "block.minecraft.cherry_wall_hanging_sign": "Gereziondozko kartel eskegia horman",
  "block.minecraft.cherry_wall_sign": "Gereziondozko kartela horman",
  "block.minecraft.cherry_wood": "Gereziondo egurra",
  "block.minecraft.chest": "Kutxa",
  "block.minecraft.chipped_anvil": "Ingude kaltetua",
  "block.minecraft.chiseled_bookshelf": "Liburu-apalategi zizelkatua",
  "block.minecraft.chiseled_copper": "Kobre zizelkatua",
  "block.minecraft.chiseled_deepslate": "Sakonetako arbel zizelkatua",
  "block.minecraft.chiseled_nether_bricks": "Netherreko adreilu zizelkatuak",
  "block.minecraft.chiseled_polished_blackstone": "Txartatutako harribeltz zizelkatua",
  "block.minecraft.chiseled_quartz_block": "Kuartzo zizelkatua",
  "block.minecraft.chiseled_red_sandstone": "Hareharri gorri zizelkatua",
  "block.minecraft.chiseled_resin_bricks": "Erretxina adreilu zizelkatuak",
  "block.minecraft.chiseled_sandstone": "Hareharri zizelkatua",
  "block.minecraft.chiseled_stone_bricks": "Harrizko adreilu zizelkatuak",
  "block.minecraft.chiseled_tuff": "Toba zizelkatua",
  "block.minecraft.chiseled_tuff_bricks": "Tobazko adreilu zizelkatuak",
  "block.minecraft.chorus_flower": "Koral lorea",
  "block.minecraft.chorus_plant": "Koral landarea",
  "block.minecraft.clay": "Buztina",
  "block.minecraft.closed_eyeblossom": "Begilore itxia",
  "block.minecraft.coal_block": "Ikatz blokea",
  "block.minecraft.coal_ore": "Ikatzezko mea",
  "block.minecraft.coarse_dirt": "Lur trokatsua",
  "block.minecraft.cobbled_deepslate": "Sakonetako arbel harritsua",
  "block.minecraft.cobbled_deepslate_slab": "Sakonetako arbel harritsuzko lauza",
  "block.minecraft.cobbled_deepslate_stairs": "Sakonetako arbel harritsuzko eskailerak",
  "block.minecraft.cobbled_deepslate_wall": "Sakonetako arbel harritsuzko horma",
  "block.minecraft.cobblestone": "Arroka",
  "block.minecraft.cobblestone_slab": "Arrokazko lauza",
  "block.minecraft.cobblestone_stairs": "Arrokazko eskailerak",
  "block.minecraft.cobblestone_wall": "Arrokazko horma",
  "block.minecraft.cobweb": "Armiarma-sarea",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Komando blokea",
  "block.minecraft.comparator": "Redstone-konparadorea",
  "block.minecraft.composter": "Konpostagailua",
  "block.minecraft.conduit": "Kanalizatzailea",
  "block.minecraft.copper_bars": "Kobrezko barrak",
  "block.minecraft.copper_block": "Kobrezko blokea",
  "block.minecraft.copper_bulb": "Kobrezko bonbilla",
  "block.minecraft.copper_chain": "Kobrezko katea",
  "block.minecraft.copper_chest": "Kobrezko kutxa",
  "block.minecraft.copper_door": "Kobrezko atea",
  "block.minecraft.copper_golem_statue": "Kobrezko golem estatua",
  "block.minecraft.copper_grate": "Kobrezko sareta",
  "block.minecraft.copper_lantern": "Kobrezko argiontzia",
  "block.minecraft.copper_ore": "Kobrezko mea",
  "block.minecraft.copper_torch": "Kobrezko argi-zuzia",
  "block.minecraft.copper_trapdoor": "Kobrezko tranpola",
  "block.minecraft.copper_wall_torch": "Kobre-zuzia horman",
  "block.minecraft.cornflower": "Nabar-lorea",
  "block.minecraft.cracked_deepslate_bricks": "Sakonetako arbelezko adreilu pitzatuak",
  "block.minecraft.cracked_deepslate_tiles": "Sakonetako arbelezko teila pitzatuak",
  "block.minecraft.cracked_nether_bricks": "Netherreko adreilu pitzatuak",
  "block.minecraft.cracked_polished_blackstone_bricks": "Txartatutako harribeltzezko adreilu pitzatuak",
  "block.minecraft.cracked_stone_bricks": "Harrizko adreilu pitzatuak",
  "block.minecraft.crafter": "Fabrikatzailea",
  "block.minecraft.crafting_table": "Lan-mahaia",
  "block.minecraft.creaking_heart": "Bihotz-karrankaria",
  "block.minecraft.creeper_head": "Creeper burua",
  "block.minecraft.creeper_wall_head": "Creeper burua paretan",
  "block.minecraft.crimson_button": "Botoi gorrimina",
  "block.minecraft.crimson_door": "Ate gorrimina",
  "block.minecraft.crimson_fence": "Hesi gorrimina",
  "block.minecraft.crimson_fence_gate": "Hesi ate gorrimina",
  "block.minecraft.crimson_fungus": "Onddo gorrimina",
  "block.minecraft.crimson_hanging_sign": "Kartel eskegi gorrimina",
  "block.minecraft.crimson_hyphae": "Hifa gorrimina",
  "block.minecraft.crimson_nylium": "Nezelio gorrimina",
  "block.minecraft.crimson_planks": "Ohol gorriminak",
  "block.minecraft.crimson_pressure_plate": "Presio plaka gorrimina",
  "block.minecraft.crimson_roots": "Sustrai gorriminak",
  "block.minecraft.crimson_shelf": "Apal gorrimina",
  "block.minecraft.crimson_sign": "Kartel gorrimina",
  "block.minecraft.crimson_slab": "Lauza gorrimina",
  "block.minecraft.crimson_stairs": "Eskailera gorriminak",
  "block.minecraft.crimson_stem": "Zurtoin gorrimina",
  "block.minecraft.crimson_trapdoor": "Tranpola gorrimina",
  "block.minecraft.crimson_wall_hanging_sign": "Kartel eskegi gorrimina horman",
  "block.minecraft.crimson_wall_sign": "Kartel gorrimina horman",
  "block.minecraft.crying_obsidian": "Obsidiana negartsua",
  "block.minecraft.cut_copper": "Moztutako kobrea",
  "block.minecraft.cut_copper_slab": "Moztutako kobrezko lauza",
  "block.minecraft.cut_copper_stairs": "Moztutako kobrezko eskailerak",
  "block.minecraft.cut_red_sandstone": "Moztutako harearri gorria",
  "block.minecraft.cut_red_sandstone_slab": "Moztutako hareharri gorrizko lauza",
  "block.minecraft.cut_sandstone": "Hareharri moztua",
  "block.minecraft.cut_sandstone_slab": "Moztutako hareharrizko lauza",
  "block.minecraft.cyan_banner": "Zutoihal ziana",
  "block.minecraft.cyan_bed": "Ohe Ziana",
  "block.minecraft.cyan_candle": "Kandela ziana",
  "block.minecraft.cyan_candle_cake": "Tarta kandela zianarekin",
  "block.minecraft.cyan_carpet": "Zian koloreko alfonbra",
  "block.minecraft.cyan_concrete": "Hormigoi Ziana",
  "block.minecraft.cyan_concrete_powder": "Zementu ziana",
  "block.minecraft.cyan_glazed_terracotta": "Terrakota beiraztatu ziana",
  "block.minecraft.cyan_shulker_box": "Shulker-kutxa ziana",
  "block.minecraft.cyan_stained_glass": "Zian koloreko kristala",
  "block.minecraft.cyan_stained_glass_pane": "Zian koloreko kristalezko panela",
  "block.minecraft.cyan_terracotta": "Terrakota ziana",
  "block.minecraft.cyan_wool": "Artile ziana",
  "block.minecraft.damaged_anvil": "Ingude hondatua",
  "block.minecraft.dandelion": "Txikoria-belar",
  "block.minecraft.dark_oak_button": "Haritz ilunezko botoia",
  "block.minecraft.dark_oak_door": "Haritz ilunezko atea",
  "block.minecraft.dark_oak_fence": "Haritz ilunezko hesia",
  "block.minecraft.dark_oak_fence_gate": "Haritz ilunezko hesi atea",
  "block.minecraft.dark_oak_hanging_sign": "Haritz ilunezko kartel eskegia",
  "block.minecraft.dark_oak_leaves": "Haritz ilun hostoak",
  "block.minecraft.dark_oak_log": "Haritz ilun enborra",
  "block.minecraft.dark_oak_planks": "Haritz ilun oholak",
  "block.minecraft.dark_oak_pressure_plate": "Haritz ilunezko presio plaka",
  "block.minecraft.dark_oak_sapling": "Haritz ilun kimua",
  "block.minecraft.dark_oak_shelf": "Haritz ilunezko apala",
  "block.minecraft.dark_oak_sign": "Haritz ilunezko kartela",
  "block.minecraft.dark_oak_slab": "Haritz ilunezko lauza",
  "block.minecraft.dark_oak_stairs": "Haritz ilunezko eskailerak",
  "block.minecraft.dark_oak_trapdoor": "Haritz ilunezko tranpola",
  "block.minecraft.dark_oak_wall_hanging_sign": "Haritz ilunezko kartel eskegia horman",
  "block.minecraft.dark_oak_wall_sign": "Haritz ilunezko kartela horman",
  "block.minecraft.dark_oak_wood": "Haritz ilun egurra",
  "block.minecraft.dark_prismarine": "Prismarina iluna",
  "block.minecraft.dark_prismarine_slab": "Prismarina ilunezko lauza",
  "block.minecraft.dark_prismarine_stairs": "Prismarina ilunezko eskailerak",
  "block.minecraft.daylight_detector": "Eguzki argi sentsorea",
  "block.minecraft.dead_brain_coral": "Bizigabeko burmuinezko koral blokea",
  "block.minecraft.dead_brain_coral_block": "Bizigabeko burmuinezko koral blokea",
  "block.minecraft.dead_brain_coral_fan": "Hildako Garuneko Coral Fan",
  "block.minecraft.dead_brain_coral_wall_fan": "Dead Brain Coral Wall Fan",
  "block.minecraft.dead_bubble_coral": "Hodizko korala",
  "block.minecraft.dead_bubble_coral_block": "Hildako Burbuila Coral Blokea",
  "block.minecraft.dead_bubble_coral_fan": "Hildako Burbuila Coral Fan",
  "block.minecraft.dead_bubble_coral_wall_fan": "Hildako burbuila koralaren horma-fan",
  "block.minecraft.dead_bush": "Zuhaixka lehorra",
  "block.minecraft.dead_fire_coral": "Bizigabeko hodizko koral blokea",
  "block.minecraft.dead_fire_coral_block": "Hildako su koral blokea",
  "block.minecraft.dead_fire_coral_fan": "Hildako Sute Coral Fan",
  "block.minecraft.dead_fire_coral_wall_fan": "Hildako sute koralaren horma-fan",
  "block.minecraft.dead_horn_coral": "Bizigabeko hodizko koral blokea",
  "block.minecraft.dead_horn_coral_block": "Hildako Egurra Coral Blokea",
  "block.minecraft.dead_horn_coral_fan": "Hildako hodizko koral fan",
  "block.minecraft.dead_horn_coral_wall_fan": "Hildako adar koralaren horma-fan",
  "block.minecraft.dead_tube_coral": "Bizigabeko hodizko koral blokea",
  "block.minecraft.dead_tube_coral_block": "Bizigabeko hodizko koral blokea",
  "block.minecraft.dead_tube_coral_fan": "Hildako Hodi Coral Fan",
  "block.minecraft.dead_tube_coral_wall_fan": "Dead Tube koralaren horma-fan",
  "block.minecraft.decorated_pot": "Apaindutako pitxerra",
  "block.minecraft.deepslate": "Sakonetako arbela",
  "block.minecraft.deepslate_brick_slab": "Sakonetako arbelezko adreiluzko lauza",
  "block.minecraft.deepslate_brick_stairs": "Sakonetako arbelezko adreiluzko eskailerak",
  "block.minecraft.deepslate_brick_wall": "Sakonetako arbelezko adreiluzko horma",
  "block.minecraft.deepslate_bricks": "Sakonetako arbelezko adreiluak",
  "block.minecraft.deepslate_coal_ore": "Ikatzezko sakonetako arbelezko mea",
  "block.minecraft.deepslate_copper_ore": "Kobrezko sakonetako arbelezko mea",
  "block.minecraft.deepslate_diamond_ore": "Diamantezko sakonetako arbelezko mea",
  "block.minecraft.deepslate_emerald_ore": "Esmeraldazko sakonetako arbelezko mea",
  "block.minecraft.deepslate_gold_ore": "Urrezko sakonetako arbelezko mea",
  "block.minecraft.deepslate_iron_ore": "Burdinazko sakonetako arbelezko mea",
  "block.minecraft.deepslate_lapis_ore": "Lapis lazulizko sakonetako arbelezko mea",
  "block.minecraft.deepslate_redstone_ore": "Redstonezko sakonetako arbelezko mea",
  "block.minecraft.deepslate_tile_slab": "Sakonetako arbelezko teilazko lauza",
  "block.minecraft.deepslate_tile_stairs": "Sakonetako arbelezko teilazko eskailerak",
  "block.minecraft.deepslate_tile_wall": "Sakonetako arbelezko teilazko horma",
  "block.minecraft.deepslate_tiles": "Sakonetako arbelezko teilak",
  "block.minecraft.detector_rail": "Detektagailudun erraila",
  "block.minecraft.diamond_block": "Diamantezko blokea",
  "block.minecraft.diamond_ore": "Diamantezko mea",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Dioritazko lauza",
  "block.minecraft.diorite_stairs": "Dioritazko eskailerak",
  "block.minecraft.diorite_wall": "Dioritazko horma",
  "block.minecraft.dirt": "Lurra",
  "block.minecraft.dirt_path": "Lur bidea",
  "block.minecraft.dispenser": "Dispentsagailua",
  "block.minecraft.dragon_egg": "Dragoiaren arrautza",
  "block.minecraft.dragon_head": "Dragoi burua",
  "block.minecraft.dragon_wall_head": "Dragoi burua paretan",
  "block.minecraft.dried_ghast": "Ghast sikua",
  "block.minecraft.dried_kelp_block": "Lehortutako alga blokea",
  "block.minecraft.dripstone_block": "Espeleotema blokea",
  "block.minecraft.dropper": "Jaurtigailua",
  "block.minecraft.emerald_block": "Esmeralda blokea",
  "block.minecraft.emerald_ore": "Esmeraldazko mea",
  "block.minecraft.enchanting_table": "Sorginkeria-mahaia",
  "block.minecraft.end_gateway": "End lotura",
  "block.minecraft.end_portal": "End ataria",
  "block.minecraft.end_portal_frame": "End atariko markoa",
  "block.minecraft.end_rod": "End barra",
  "block.minecraft.end_stone": "Endeko harria",
  "block.minecraft.end_stone_brick_slab": "Endeko harrizko adreiluzko lauza",
  "block.minecraft.end_stone_brick_stairs": "Endeko harrizko adreiluzko eskailerak",
  "block.minecraft.end_stone_brick_wall": "Endeko harrizko adreiluzko horma",
  "block.minecraft.end_stone_bricks": "Endeko harrizko adreiluak",
  "block.minecraft.ender_chest": "Ender-kutxa",
  "block.minecraft.exposed_chiseled_copper": "Kobre estalgabetu zizelkatua",
  "block.minecraft.exposed_copper": "Kobre estalgabetua",
  "block.minecraft.exposed_copper_bars": "Kobrezko barra estalgabetuak",
  "block.minecraft.exposed_copper_bulb": "Kobrezko bonbilla estalgabetua",
  "block.minecraft.exposed_copper_chain": "Kobrezko kate estalgabetua",
  "block.minecraft.exposed_copper_chest": "Kobrezko kutxa estalgabetua",
  "block.minecraft.exposed_copper_door": "Kobrezko ate estalgabetua",
  "block.minecraft.exposed_copper_golem_statue": "Kobrezko golem estatua estalgabetua",
  "block.minecraft.exposed_copper_grate": "Kobrezko sareta estalgabetua",
  "block.minecraft.exposed_copper_lantern": "Kobrezko argiontzi estalgabetua",
  "block.minecraft.exposed_copper_trapdoor": "Kobrezko tranpol estalgabetua",
  "block.minecraft.exposed_cut_copper": "Moztutako kobre estalgabetua",
  "block.minecraft.exposed_cut_copper_slab": "Moztutako kobrezko lauza estalgabetua",
  "block.minecraft.exposed_cut_copper_stairs": "Moztutako kobrezko eskailera estalgabetuak",
  "block.minecraft.exposed_lightning_rod": "Kobrezko tximistorratz estalgabetua",
  "block.minecraft.farmland": "Saila",
  "block.minecraft.fern": "Iratzea",
  "block.minecraft.fire": "Sua",
  "block.minecraft.fire_coral": "Hodizko korala",
  "block.minecraft.fire_coral_block": "Bizigabeko su koral blokea",
  "block.minecraft.fire_coral_fan": "Hodizko korala",
  "block.minecraft.fire_coral_wall_fan": "Fire Coral Wall Fan",
  "block.minecraft.firefly_bush": "Ipurtargi-zuhaixka",
  "block.minecraft.fletching_table": "Geziak egiteko taula",
  "block.minecraft.flower_pot": "Loreontzi",
  "block.minecraft.flowering_azalea": "Azalea loretan",
  "block.minecraft.flowering_azalea_leaves": "Loretutako azalearen hostoak",
  "block.minecraft.frogspawn": "Igel arrabak",
  "block.minecraft.frosted_ice": "Izotz zuri",
  "block.minecraft.furnace": "Labea",
  "block.minecraft.gilded_blackstone": "Urreztatutako harribeltza",
  "block.minecraft.glass": "Kristala",
  "block.minecraft.glass_pane": "Kristalezko panela",
  "block.minecraft.glow_lichen": "Liken distiratsua",
  "block.minecraft.glowstone": "Argi-harria",
  "block.minecraft.gold_block": "Urrezko blokea",
  "block.minecraft.gold_ore": "Urrezko mea",
  "block.minecraft.golden_dandelion": "Urrezko txikoria",
  "block.minecraft.granite": "Granitoa",
  "block.minecraft.granite_slab": "Ganito lauza",
  "block.minecraft.granite_stairs": "Ganito eskailerak",
  "block.minecraft.granite_wall": "Granito horma",
  "block.minecraft.grass": "Belarra",
  "block.minecraft.grass_block": "Belar blokea",
  "block.minecraft.gravel": "Legarra",
  "block.minecraft.gray_banner": "Zutoihal grisa",
  "block.minecraft.gray_bed": "Ohe Grisa",
  "block.minecraft.gray_candle": "Kandela grisa",
  "block.minecraft.gray_candle_cake": "Tarta kandela grisarekin",
  "block.minecraft.gray_carpet": "Gris koloreko alfonbra",
  "block.minecraft.gray_concrete": "Hormigoi Grisa",
  "block.minecraft.gray_concrete_powder": "Zementu grisa",
  "block.minecraft.gray_glazed_terracotta": "Terrakota beiraztatu grisa",
  "block.minecraft.gray_shulker_box": "Shulker-kutxa grisa",
  "block.minecraft.gray_stained_glass": "Kristal grisa",
  "block.minecraft.gray_stained_glass_pane": "Kristalezko panel grisa",
  "block.minecraft.gray_terracotta": "Terrakota grisa",
  "block.minecraft.gray_wool": "Artile grisa",
  "block.minecraft.green_banner": "Zutoihal berdea",
  "block.minecraft.green_bed": "Ohe Berdea",
  "block.minecraft.green_candle": "Kandela berdea",
  "block.minecraft.green_candle_cake": "Tarta kandela berdearekin",
  "block.minecraft.green_carpet": "Berde koloreko alfonbra",
  "block.minecraft.green_concrete": "Hormigoi Berdea",
  "block.minecraft.green_concrete_powder": "Zementu berdea",
  "block.minecraft.green_glazed_terracotta": "Terrakota beiraztatu berdea",
  "block.minecraft.green_shulker_box": "Shulker-kutxa berdea",
  "block.minecraft.green_stained_glass": "Kristal berdea",
  "block.minecraft.green_stained_glass_pane": "Kristalezko panel berdea",
  "block.minecraft.green_terracotta": "Terrakota berdea",
  "block.minecraft.green_wool": "Artile berdea",
  "block.minecraft.grindstone": "Zorrozkailua",
  "block.minecraft.hanging_roots": "Sustrai zintzilikariak",
  "block.minecraft.hay_block": "Lasto fardoa",
  "block.minecraft.heavy_core": "Nukleo astuna",
  "block.minecraft.heavy_weighted_pressure_plate": "Presio plaka astuna",
  "block.minecraft.honey_block": "Ezti blokea",
  "block.minecraft.honeycomb_block": "Abaraska",
  "block.minecraft.hopper": "Tobera",
  "block.minecraft.horn_coral": "Hodizko korala",
  "block.minecraft.horn_coral_block": "Bizigabeko adar koral blokea",
  "block.minecraft.horn_coral_fan": "Hodizko korala",
  "block.minecraft.horn_coral_wall_fan": "Adar koralaren horma-fan",
  "block.minecraft.ice": "Izotza",
  "block.minecraft.infested_chiseled_stone_bricks": "Izurritutako harrizko adreilu zizelkatuak",
  "block.minecraft.infested_cobblestone": "Izurritutako arroka",
  "block.minecraft.infested_cracked_stone_bricks": "Izurritutako harrizko adreilu pitzatuak",
  "block.minecraft.infested_deepslate": "Izurritutako sakonetako arbela",
  "block.minecraft.infested_mossy_stone_bricks": "Izurritutako harri goroldiotsuzko adreiluak",
  "block.minecraft.infested_stone": "Izurritutako harria",
  "block.minecraft.infested_stone_bricks": "Izurritutako harrizko adreiluak",
  "block.minecraft.iron_bars": "Burdinazko barrak",
  "block.minecraft.iron_block": "Burdinazko blokea",
  "block.minecraft.iron_chain": "Burdinazko katea",
  "block.minecraft.iron_door": "Burdinazko atea",
  "block.minecraft.iron_ore": "Burdinazko mea",
  "block.minecraft.iron_trapdoor": "Burdinazko tranpola",
  "block.minecraft.jack_o_lantern": "Kalabaza linterna",
  "block.minecraft.jigsaw": "Buruhausgarri blokea",
  "block.minecraft.jukebox": "Musika kaxa",
  "block.minecraft.jungle_button": "Oihanezko botoia",
  "block.minecraft.jungle_door": "Oihanezko atea",
  "block.minecraft.jungle_fence": "Ohianezko hesia",
  "block.minecraft.jungle_fence_gate": "Ohianezko hesi atea",
  "block.minecraft.jungle_hanging_sign": "Oihanezko kartel eskegia",
  "block.minecraft.jungle_leaves": "Oihan hostoak",
  "block.minecraft.jungle_log": "Oihan enborra",
  "block.minecraft.jungle_planks": "Oihan oholak",
  "block.minecraft.jungle_pressure_plate": "Oihanezko presio plaka",
  "block.minecraft.jungle_sapling": "Oihan kimua",
  "block.minecraft.jungle_shelf": "Oihanezko apala",
  "block.minecraft.jungle_sign": "Oihanezko kartela",
  "block.minecraft.jungle_slab": "Oihanezko lauza",
  "block.minecraft.jungle_stairs": "Oihanezko eskailerak",
  "block.minecraft.jungle_trapdoor": "Oihanezko tranpola",
  "block.minecraft.jungle_wall_hanging_sign": "Oihanezko kartel eskegia horman",
  "block.minecraft.jungle_wall_sign": "Oihanezko kartela horman",
  "block.minecraft.jungle_wood": "Oihan egurra",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Alga landarea",
  "block.minecraft.ladder": "Zurubia",
  "block.minecraft.lantern": "Argiontzia",
  "block.minecraft.lapis_block": "Lapis lazuli blokea",
  "block.minecraft.lapis_ore": "Lapis lazulizko mea",
  "block.minecraft.large_amethyst_bud": "Ametista ernamuin handia",
  "block.minecraft.large_fern": "Iratze handia",
  "block.minecraft.lava": "Laba",
  "block.minecraft.lava_cauldron": "Laba galdara",
  "block.minecraft.leaf_litter": "Orbelak",
  "block.minecraft.lectern": "Atrila",
  "block.minecraft.lever": "Palanka",
  "block.minecraft.light": "Argia",
  "block.minecraft.light_blue_banner": "Zutoihal urdin argia",
  "block.minecraft.light_blue_bed": "Ohe Urdin Argia",
  "block.minecraft.light_blue_candle": "Kandela urdin argia",
  "block.minecraft.light_blue_candle_cake": "Tarta kandela urdin argiarekin",
  "block.minecraft.light_blue_carpet": "Urdin argi koloreko alfonbra",
  "block.minecraft.light_blue_concrete": "Hormigoi Urdin Argia",
  "block.minecraft.light_blue_concrete_powder": "Zementu urdin argia",
  "block.minecraft.light_blue_glazed_terracotta": "Terrakota beiraztatu urdin argia",
  "block.minecraft.light_blue_shulker_box": "Shulker-kutxa urdin argia",
  "block.minecraft.light_blue_stained_glass": "Kristal urdin argia",
  "block.minecraft.light_blue_stained_glass_pane": "Kristalezko panel urdin argia",
  "block.minecraft.light_blue_terracotta": "Terrakota urdin argia",
  "block.minecraft.light_blue_wool": "Artile urdin argia",
  "block.minecraft.light_gray_banner": "Zutoihal gris argia",
  "block.minecraft.light_gray_bed": "Ohe Gris Argia",
  "block.minecraft.light_gray_candle": "Kandela gris argia",
  "block.minecraft.light_gray_candle_cake": "Tarta kandela gris argiarekin",
  "block.minecraft.light_gray_carpet": "Alfonbra gris argia",
  "block.minecraft.light_gray_concrete": "Hormigoi Gris Argia",
  "block.minecraft.light_gray_concrete_powder": "Zementu gris argia",
  "block.minecraft.light_gray_glazed_terracotta": "Terrakota beiraztatu gris argia",
  "block.minecraft.light_gray_shulker_box": "Shulker-kutxa gris argia",
  "block.minecraft.light_gray_stained_glass": "Kristal gris argia",
  "block.minecraft.light_gray_stained_glass_pane": "Kristalezko panel gris argia",
  "block.minecraft.light_gray_terracotta": "Terrakota gris argia",
  "block.minecraft.light_gray_wool": "Artile gris argia",
  "block.minecraft.light_weighted_pressure_plate": "Presio plaka arina",
  "block.minecraft.lightning_rod": "Tximistorratza",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Mugeta",
  "block.minecraft.lily_pad": "Igebelarra",
  "block.minecraft.lime_banner": "Zutohial lima",
  "block.minecraft.lime_bed": "Ohe Lima",
  "block.minecraft.lime_candle": "Kandela lima",
  "block.minecraft.lime_candle_cake": "Tarta kandela limarekin",
  "block.minecraft.lime_carpet": "Lima koloreko alfonbra",
  "block.minecraft.lime_concrete": "Hormigoi Lima",
  "block.minecraft.lime_concrete_powder": "Zementu lima",
  "block.minecraft.lime_glazed_terracotta": "Terrakota beiraztatu lima",
  "block.minecraft.lime_shulker_box": "Shulker-kutxa lima",
  "block.minecraft.lime_stained_glass": "Kristal lima",
  "block.minecraft.lime_stained_glass_pane": "Lima koloreko kristalezko panela",
  "block.minecraft.lime_terracotta": "Terrakota lima",
  "block.minecraft.lime_wool": "Artile lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Ehungailua",
  "block.minecraft.magenta_banner": "Zutoihal magenta",
  "block.minecraft.magenta_bed": "Ohe Magenta",
  "block.minecraft.magenta_candle": "Kandela magenta",
  "block.minecraft.magenta_candle_cake": "Tarta kandela magentarekin",
  "block.minecraft.magenta_carpet": "Magenta koloreko alfonbra",
  "block.minecraft.magenta_concrete": "Hormigoi Magenta",
  "block.minecraft.magenta_concrete_powder": "Zementu magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terrakota beiraztatu magenta",
  "block.minecraft.magenta_shulker_box": "Shulker-kutxa magenta",
  "block.minecraft.magenta_stained_glass": "Kristal magenta",
  "block.minecraft.magenta_stained_glass_pane": "Kristalezko panel magenta",
  "block.minecraft.magenta_terracotta": "Terrakota magenta",
  "block.minecraft.magenta_wool": "Artile magenta",
  "block.minecraft.magma_block": "Magma blokea",
  "block.minecraft.mangrove_button": "Manglezko botoia",
  "block.minecraft.mangrove_door": "Manglezko atea",
  "block.minecraft.mangrove_fence": "Manglezko hesia",
  "block.minecraft.mangrove_fence_gate": "Manglezko hesi atea",
  "block.minecraft.mangrove_hanging_sign": "Manglezko kartel eskegia",
  "block.minecraft.mangrove_leaves": "Mangle hostoak",
  "block.minecraft.mangrove_log": "Mangle enborra",
  "block.minecraft.mangrove_planks": "Mangle oholak",
  "block.minecraft.mangrove_pressure_plate": "Manglezko presio plaka",
  "block.minecraft.mangrove_propagule": "Mangle propagulua",
  "block.minecraft.mangrove_roots": "Mangle sustraiak",
  "block.minecraft.mangrove_shelf": "Manglezko apala",
  "block.minecraft.mangrove_sign": "Manglezko kartela",
  "block.minecraft.mangrove_slab": "Manglezko lauza",
  "block.minecraft.mangrove_stairs": "Manglezko eskailerak",
  "block.minecraft.mangrove_trapdoor": "Manglezko tranpola",
  "block.minecraft.mangrove_wall_hanging_sign": "Manglezko kartel eskegia horman",
  "block.minecraft.mangrove_wall_sign": "Manglezko kartela horman",
  "block.minecraft.mangrove_wood": "Mangle egurra",
  "block.minecraft.medium_amethyst_bud": "Ametista ernamuin ertaina",
  "block.minecraft.melon": "Meloia",
  "block.minecraft.melon_stem": "Meloi zurtoina",
  "block.minecraft.moss_block": "Goroldio blokea",
  "block.minecraft.moss_carpet": "Goroldio geruza",
  "block.minecraft.mossy_cobblestone": "Arroka goroldiotsua",
  "block.minecraft.mossy_cobblestone_slab": "Arroka goroldiotsuzko lauza",
  "block.minecraft.mossy_cobblestone_stairs": "Arroka goroldiotsuzko eskailerak",
  "block.minecraft.mossy_cobblestone_wall": "Arroka goroldiotsuzko horma",
  "block.minecraft.mossy_stone_brick_slab": "Harri goroldiotsuzko adreiluzko lauza",
  "block.minecraft.mossy_stone_brick_stairs": "Harri goroldiotsu adreiluzko eskailerak",
  "block.minecraft.mossy_stone_brick_wall": "Harri goroldiotsu adreiluzko horma",
  "block.minecraft.mossy_stone_bricks": "Harri goroldiotsuzko adreiluak",
  "block.minecraft.moving_piston": "Pistoia mugimenduan",
  "block.minecraft.mud": "Lokatza",
  "block.minecraft.mud_brick_slab": "Lokatzezko adreiluzko lauza",
  "block.minecraft.mud_brick_stairs": "Lokatzezko adreiluzko eskailerak",
  "block.minecraft.mud_brick_wall": "Lokatzazko adreiluzko horma",
  "block.minecraft.mud_bricks": "Lokatzezko adreiluak",
  "block.minecraft.muddy_mangrove_roots": "Mangle sustrai lokaztuak",
  "block.minecraft.mushroom_stem": "Perretxiko zurtoina",
  "block.minecraft.mycelium": "Mizelioa",
  "block.minecraft.nether_brick_fence": "Netherreko adreiluzko hesia",
  "block.minecraft.nether_brick_slab": "Netherreko adreiluzko lauza",
  "block.minecraft.nether_brick_stairs": "Netherreko adreiluzko eskailerak",
  "block.minecraft.nether_brick_wall": "Netherreko adreiluzko horma",
  "block.minecraft.nether_bricks": "Netherreko adreiluak",
  "block.minecraft.nether_gold_ore": "Netherreko urrezko mea",
  "block.minecraft.nether_portal": "Netherreko ataria",
  "block.minecraft.nether_quartz_ore": "Netherreko kuartzozko mea",
  "block.minecraft.nether_sprouts": "Netherreko ernamuinak",
  "block.minecraft.nether_wart": "Netherreko garatxoa",
  "block.minecraft.nether_wart_block": "Netherreko garatxozko blokea",
  "block.minecraft.netherite_block": "Netheritazko blokea",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nota blokea",
  "block.minecraft.oak_button": "Haritzezko botoia",
  "block.minecraft.oak_door": "Haritzezko atea",
  "block.minecraft.oak_fence": "Haritzezko hesia",
  "block.minecraft.oak_fence_gate": "Haritzezko hesi atea",
  "block.minecraft.oak_hanging_sign": "Haritzezko kartel eskegia",
  "block.minecraft.oak_leaves": "Haritz hostoak",
  "block.minecraft.oak_log": "Haritz enborra",
  "block.minecraft.oak_planks": "Haritz oholak",
  "block.minecraft.oak_pressure_plate": "Haritzezko presio plaka",
  "block.minecraft.oak_sapling": "Haritz kimua",
  "block.minecraft.oak_shelf": "Haritzezko apala",
  "block.minecraft.oak_sign": "Haritzezko kartela",
  "block.minecraft.oak_slab": "Haritzezko lauza",
  "block.minecraft.oak_stairs": "Haritzezko eskailerak",
  "block.minecraft.oak_trapdoor": "Haritzezko tranpola",
  "block.minecraft.oak_wall_hanging_sign": "Haritzezko kartel eskegia horman",
  "block.minecraft.oak_wall_sign": "Haritzezko kartela horman",
  "block.minecraft.oak_wood": "Haritz egurra",
  "block.minecraft.observer": "Behatzailea",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Igelargi okrea",
  "block.minecraft.ominous_banner": "Zutoihal zorigaiztoa",
  "block.minecraft.open_eyeblossom": "Begilore irekia",
  "block.minecraft.orange_banner": "Zutoihal laranja",
  "block.minecraft.orange_bed": "Ohe Laranja",
  "block.minecraft.orange_candle": "Kandela laranja",
  "block.minecraft.orange_candle_cake": "Tarta kandela naranjarekin",
  "block.minecraft.orange_carpet": "Laranja koloreko alfonbra",
  "block.minecraft.orange_concrete": "Hormigoi Laranja",
  "block.minecraft.orange_concrete_powder": "Zementu laranja",
  "block.minecraft.orange_glazed_terracotta": "Terrakota beiraztatu laranja",
  "block.minecraft.orange_shulker_box": "Shulker-kutxa laranja",
  "block.minecraft.orange_stained_glass": "Kristal laranja",
  "block.minecraft.orange_stained_glass_pane": "Kristalezko panel laranja",
  "block.minecraft.orange_terracotta": "Terrakota laranja",
  "block.minecraft.orange_tulip": "Tulipa laranja",
  "block.minecraft.orange_wool": "Artile laranja",
  "block.minecraft.oxeye_daisy": "Sanjoan-lorea",
  "block.minecraft.oxidized_chiseled_copper": "Kobre herdoildu zizelkatua",
  "block.minecraft.oxidized_copper": "Kobre herdoildua",
  "block.minecraft.oxidized_copper_bars": "Kobrezko barra herdoilduak",
  "block.minecraft.oxidized_copper_bulb": "Kobrezko bonbilla herdoildua",
  "block.minecraft.oxidized_copper_chain": "Kobrezko kate herdoildua",
  "block.minecraft.oxidized_copper_chest": "Kobrezko kutxa herdoildua",
  "block.minecraft.oxidized_copper_door": "Kobrezko ate herdoildua",
  "block.minecraft.oxidized_copper_golem_statue": "Kobrezko golem estatua herdoildua",
  "block.minecraft.oxidized_copper_grate": "Kobrezko sareta herdoildua",
  "block.minecraft.oxidized_copper_lantern": "Kobrezko argiontzi herdoildua",
  "block.minecraft.oxidized_copper_trapdoor": "Kobrezko tranpol herdoildua",
  "block.minecraft.oxidized_cut_copper": "Moztutako kobre herdoildua",
  "block.minecraft.oxidized_cut_copper_slab": "Moztutako kobrezko lauza herdoildua",
  "block.minecraft.oxidized_cut_copper_stairs": "Moztutako kobrezko eskailera herdoilduak",
  "block.minecraft.oxidized_lightning_rod": "Kobrezko tximistorratz herdoildua",
  "block.minecraft.packed_ice": "Izotz konprimitua",
  "block.minecraft.packed_mud": "Lokatz trinkoa",
  "block.minecraft.pale_hanging_moss": "Goroldio zurbil eskegia",
  "block.minecraft.pale_moss_block": "Goroldio zurbil blokea",
  "block.minecraft.pale_moss_carpet": "Goroldio zurbil geruza",
  "block.minecraft.pale_oak_button": "Haritz zurbilezko botoia",
  "block.minecraft.pale_oak_door": "Haritz zurbilezko atea",
  "block.minecraft.pale_oak_fence": "Haritz zurbilezko hesia",
  "block.minecraft.pale_oak_fence_gate": "Haritz zurbilezko hesi atea",
  "block.minecraft.pale_oak_hanging_sign": "Haritz zurbilezko kartel eskegia",
  "block.minecraft.pale_oak_leaves": "Haritz zurbilezko hostoak",
  "block.minecraft.pale_oak_log": "Haritz zurbilezko enborra",
  "block.minecraft.pale_oak_planks": "Haritz zurbilezko oholak",
  "block.minecraft.pale_oak_pressure_plate": "Haritz zurbilezko presio plaka",
  "block.minecraft.pale_oak_sapling": "Haritz zurbil kimua",
  "block.minecraft.pale_oak_shelf": "Haritz zurbilezko apala",
  "block.minecraft.pale_oak_sign": "Haritz zurbilezko kartela",
  "block.minecraft.pale_oak_slab": "Haritz zurbilezko lauza",
  "block.minecraft.pale_oak_stairs": "Haritz zurbilezko eskailerak",
  "block.minecraft.pale_oak_trapdoor": "Haritz zurbilezko tranpola",
  "block.minecraft.pale_oak_wall_hanging_sign": "Haritz zurbilezko kartel eskegia horman",
  "block.minecraft.pale_oak_wall_sign": "Haritz zurbilezko kartela horman",
  "block.minecraft.pale_oak_wood": "Haritz zurbil egurra",
  "block.minecraft.pearlescent_froglight": "Igelargi nakar-kolorekoa",
  "block.minecraft.peony": "Oinlodia",
  "block.minecraft.petrified_oak_slab": "Harritutako haritzezko lauza",
  "block.minecraft.piglin_head": "Piglin burua",
  "block.minecraft.piglin_wall_head": "Piglin buru trofeoa",
  "block.minecraft.pink_banner": "Zutoihal arrosa",
  "block.minecraft.pink_bed": "Ohe Arrosa",
  "block.minecraft.pink_candle": "Kandela arrosa",
  "block.minecraft.pink_candle_cake": "Tarta kandela arrosarekin",
  "block.minecraft.pink_carpet": "Arrosa koloreko alfonbra",
  "block.minecraft.pink_concrete": "Hormigoi Arrosa",
  "block.minecraft.pink_concrete_powder": "Zementu arrosa",
  "block.minecraft.pink_glazed_terracotta": "Terrakota beiraztatu arrosa",
  "block.minecraft.pink_petals": "Lore-hosto arrosak",
  "block.minecraft.pink_shulker_box": "Shulker-kutxa arrosa",
  "block.minecraft.pink_stained_glass": "Kristal arrosa",
  "block.minecraft.pink_stained_glass_pane": "Kristalezko panel arrosa",
  "block.minecraft.pink_terracotta": "Terrakota arrosa",
  "block.minecraft.pink_tulip": "Idi-bihotz arrosa",
  "block.minecraft.pink_wool": "Artile arrosa",
  "block.minecraft.piston": "Pistoia",
  "block.minecraft.piston_head": "Pistoi burua",
  "block.minecraft.pitcher_crop": "Landareak pitxerrean",
  "block.minecraft.pitcher_plant": "Pitxer landarea",
  "block.minecraft.player_head": "Jokalari burua",
  "block.minecraft.player_head.named": "%s-(r)en burua",
  "block.minecraft.player_wall_head": "Jokalariaren burua paretan",
  "block.minecraft.podzol": "Podsola",
  "block.minecraft.pointed_dripstone": "Espeleotema puntazorrotza",
  "block.minecraft.polished_andesite": "Txartatutako andesita",
  "block.minecraft.polished_andesite_slab": "Txartatutako andesitazko lauza",
  "block.minecraft.polished_andesite_stairs": "Txartatutako andesitazko eskailerak",
  "block.minecraft.polished_basalt": "Txartatutako basaltoa",
  "block.minecraft.polished_blackstone": "Txartatutako harribeltza",
  "block.minecraft.polished_blackstone_brick_slab": "Txartatutako harribeltzezko adreiluzko lauza",
  "block.minecraft.polished_blackstone_brick_stairs": "Txartatutako harribeltzezko adreiluzko eskailerak",
  "block.minecraft.polished_blackstone_brick_wall": "Txartatutako harribeltzezko adreiluzko horma",
  "block.minecraft.polished_blackstone_bricks": "Txartatutako harribeltzezko adreiluak",
  "block.minecraft.polished_blackstone_button": "Txartatutako harribeltzezko botoia",
  "block.minecraft.polished_blackstone_pressure_plate": "Txartatutako harribeltzezko presio plaka",
  "block.minecraft.polished_blackstone_slab": "Txartatutako harribeltzezko lauza",
  "block.minecraft.polished_blackstone_stairs": "Txartatutako harribeltzezko eskailerak",
  "block.minecraft.polished_blackstone_wall": "Txartatutako harribeltzezko horma",
  "block.minecraft.polished_deepslate": "Txartatutako sakonetako arbela",
  "block.minecraft.polished_deepslate_slab": "Txartatutako sakonetako arbelezko lauza",
  "block.minecraft.polished_deepslate_stairs": "Txartatutako sakonetako arbelezko eskailerak",
  "block.minecraft.polished_deepslate_wall": "Txartatutako sakonetako arbelezko horma",
  "block.minecraft.polished_diorite": "Txartatutako diorita",
  "block.minecraft.polished_diorite_slab": "Txartatutako dioritazko lauza",
  "block.minecraft.polished_diorite_stairs": "Txartatutako dioritazko eskailerak",
  "block.minecraft.polished_granite": "Txartatutako granitoa",
  "block.minecraft.polished_granite_slab": "Txartatutako granitozko lauza",
  "block.minecraft.polished_granite_stairs": "Txartatutako granitozko eskailerak",
  "block.minecraft.polished_tuff": "Toba leuna",
  "block.minecraft.polished_tuff_slab": "Toba Lauza leuna",
  "block.minecraft.polished_tuff_stairs": "Toba eskailera leunak",
  "block.minecraft.polished_tuff_wall": "Toba Horma leuna",
  "block.minecraft.poppy": "Mitxoleta",
  "block.minecraft.potatoes": "Patatak",
  "block.minecraft.potted_acacia_sapling": "Akazia kimu landatua",
  "block.minecraft.potted_allium": "Allium landatua",
  "block.minecraft.potted_azalea_bush": "Azalea landatua",
  "block.minecraft.potted_azure_bluet": "Bluet urdin argi landatua",
  "block.minecraft.potted_bamboo": "Banbu landatua",
  "block.minecraft.potted_birch_sapling": "Urki kimu landatua",
  "block.minecraft.potted_blue_orchid": "Orkide urdin landatua",
  "block.minecraft.potted_brown_mushroom": "Perretxiko marroi landatua",
  "block.minecraft.potted_cactus": "Kaktus landatua",
  "block.minecraft.potted_cherry_sapling": "Gereziondo kimu landatua",
  "block.minecraft.potted_closed_eyeblossom": "Begilore itxi landatua",
  "block.minecraft.potted_cornflower": "Nabar-lore landatua",
  "block.minecraft.potted_crimson_fungus": "Onddo gorrimin landatua",
  "block.minecraft.potted_crimson_roots": "Sustrai gorrimin landatuak",
  "block.minecraft.potted_dandelion": "Txikoria-belar landatua",
  "block.minecraft.potted_dark_oak_sapling": "Haritz ilun kimu landatua",
  "block.minecraft.potted_dead_bush": "Zuhaixka lehor landatua",
  "block.minecraft.potted_fern": "Iratze landatua",
  "block.minecraft.potted_flowering_azalea_bush": "Loratutako azalea landatua",
  "block.minecraft.potted_golden_dandelion": "Urrezko txikoria landatua",
  "block.minecraft.potted_jungle_sapling": "Oihan kimu landatua",
  "block.minecraft.potted_lily_of_the_valley": "Mugeta landatua",
  "block.minecraft.potted_mangrove_propagule": "Mangle propagulu landatua",
  "block.minecraft.potted_oak_sapling": "Haritz kimu landatua",
  "block.minecraft.potted_open_eyeblossom": "Begilore ireki landatua",
  "block.minecraft.potted_orange_tulip": "Tulipa laranja landatua",
  "block.minecraft.potted_oxeye_daisy": "Sanjoan-lore landatua",
  "block.minecraft.potted_pale_oak_sapling": "Haritz zurbil kimu landatua",
  "block.minecraft.potted_pink_tulip": "Tulipa arrosa landatua",
  "block.minecraft.potted_poppy": "Mitxoleta landatua",
  "block.minecraft.potted_red_mushroom": "Perretxiko gorri landatua",
  "block.minecraft.potted_red_tulip": "Tulipa gorri landatua",
  "block.minecraft.potted_spruce_sapling": "Izei kimu landatua",
  "block.minecraft.potted_torchflower": "Lastargi-lorea loreontzian",
  "block.minecraft.potted_warped_fungus": "Onddo okertu landatua",
  "block.minecraft.potted_warped_roots": "Sustrai okertu landatuak",
  "block.minecraft.potted_white_tulip": "Tulipa zuri landatua",
  "block.minecraft.potted_wither_rose": "Wither arrosa landatua",
  "block.minecraft.powder_snow": "Elur-hautsa",
  "block.minecraft.powder_snow_cauldron": "Elur-hauts galdara",
  "block.minecraft.powered_rail": "Propultsagailudun erraila",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Prismarinazko adreiluzko lauza",
  "block.minecraft.prismarine_brick_stairs": "Prismarinazko adreiluzko eskailerak",
  "block.minecraft.prismarine_bricks": "Prismarinazko adreiluak",
  "block.minecraft.prismarine_slab": "Prismarinazko lauza",
  "block.minecraft.prismarine_stairs": "Prismarinazko eskailerak",
  "block.minecraft.prismarine_wall": "Prismarinazko horma",
  "block.minecraft.pumpkin": "Kalabaza",
  "block.minecraft.pumpkin_stem": "Kalabaza zurtoina",
  "block.minecraft.purple_banner": "Zutoihal morea",
  "block.minecraft.purple_bed": "Ohe Morea",
  "block.minecraft.purple_candle": "Kandela morea",
  "block.minecraft.purple_candle_cake": "Tarta kandela morearekin",
  "block.minecraft.purple_carpet": "More koloreko alfonbra",
  "block.minecraft.purple_concrete": "Hormigoi Morea",
  "block.minecraft.purple_concrete_powder": "Zementu morea",
  "block.minecraft.purple_glazed_terracotta": "Terrakota beiraztatu morea",
  "block.minecraft.purple_shulker_box": "Shulker-kutxa morea",
  "block.minecraft.purple_stained_glass": "Kristal morea",
  "block.minecraft.purple_stained_glass_pane": "Kristalezko panel morea",
  "block.minecraft.purple_terracotta": "Terrakota morea",
  "block.minecraft.purple_wool": "Artile morea",
  "block.minecraft.purpur_block": "Purpurezko blokea",
  "block.minecraft.purpur_pillar": "Purpurezko zutabea",
  "block.minecraft.purpur_slab": "Purpurezko lauza",
  "block.minecraft.purpur_stairs": "Purpurezko eskailerak",
  "block.minecraft.quartz_block": "Kuartzo blokea",
  "block.minecraft.quartz_bricks": "Kuartzozko adreiluak",
  "block.minecraft.quartz_pillar": "Kuartzozko zutabea",
  "block.minecraft.quartz_slab": "Kuartzozko lauza",
  "block.minecraft.quartz_stairs": "Kuartzozko eskailerak",
  "block.minecraft.rail": "Erraila",
  "block.minecraft.raw_copper_block": "Kobrezko bloke landugabea",
  "block.minecraft.raw_gold_block": "Urrezko bloke landugabea",
  "block.minecraft.raw_iron_block": "Burdinazko bloke landugabea",
  "block.minecraft.red_banner": "Zutoihal gorria",
  "block.minecraft.red_bed": "Ohe Gorria",
  "block.minecraft.red_candle": "Kandela gorria",
  "block.minecraft.red_candle_cake": "Tarta kandela gorriarekin",
  "block.minecraft.red_carpet": "Gorri koloreko alfonbra",
  "block.minecraft.red_concrete": "Hormigoi Gorria",
  "block.minecraft.red_concrete_powder": "Zementu gorria",
  "block.minecraft.red_glazed_terracotta": "Terrakota beiraztatu gorria",
  "block.minecraft.red_mushroom": "Onddo gorria",
  "block.minecraft.red_mushroom_block": "Perretxiko gorrizko blokea",
  "block.minecraft.red_nether_brick_slab": "Netherreko adreilu gorrizko lauza",
  "block.minecraft.red_nether_brick_stairs": "Netherreko adreilu gorrizko eskailerak",
  "block.minecraft.red_nether_brick_wall": "Netherreko adreilu gorrizko horma",
  "block.minecraft.red_nether_bricks": "Netherreko adreilu gorriak",
  "block.minecraft.red_sand": "Hare-gorria",
  "block.minecraft.red_sandstone": "Hareharri gorria",
  "block.minecraft.red_sandstone_slab": "Hareharri gorrizko lauza",
  "block.minecraft.red_sandstone_stairs": "Hareharri gorrizko eskailerak",
  "block.minecraft.red_sandstone_wall": "Hareharri gorrizko pareta",
  "block.minecraft.red_shulker_box": "Shulker-kutxa gorria",
  "block.minecraft.red_stained_glass": "Kristal gorria",
  "block.minecraft.red_stained_glass_pane": "Kristalezko panel gorria",
  "block.minecraft.red_terracotta": "Terrakota gorria",
  "block.minecraft.red_tulip": "Tulipa gorria",
  "block.minecraft.red_wool": "Artile gorria",
  "block.minecraft.redstone_block": "Redstonezko blokea",
  "block.minecraft.redstone_lamp": "Redstone-lanpara",
  "block.minecraft.redstone_ore": "Redstonezko mea",
  "block.minecraft.redstone_torch": "Redstone-zuzia",
  "block.minecraft.redstone_wall_torch": "Redstone-zuzia horman",
  "block.minecraft.redstone_wire": "Redstone-kablea",
  "block.minecraft.reinforced_deepslate": "Sakonetako arbel indartua",
  "block.minecraft.repeater": "Redstone-errepikagailua",
  "block.minecraft.repeating_command_block": "Iterazio-komando blokea",
  "block.minecraft.resin_block": "Erretxina blokea",
  "block.minecraft.resin_brick_slab": "Erretxina adreiluzko lauza",
  "block.minecraft.resin_brick_stairs": "Erretxina adreiluzko eskailerak",
  "block.minecraft.resin_brick_wall": "Erretxina adreiluzko horma",
  "block.minecraft.resin_bricks": "Erretxina adreiluak",
  "block.minecraft.resin_clump": "Erretxina mamitsua",
  "block.minecraft.respawn_anchor": "Berragertze-lotura",
  "block.minecraft.rooted_dirt": "Lur sustraitsua",
  "block.minecraft.rose_bush": "Arrosondoa",
  "block.minecraft.sand": "Harea",
  "block.minecraft.sandstone": "Hareharri",
  "block.minecraft.sandstone_slab": "Hareharrizko lauza",
  "block.minecraft.sandstone_stairs": "Hareharrizko eskailerak",
  "block.minecraft.sandstone_wall": "Hareharri pareta",
  "block.minecraft.scaffolding": "Aldamioa",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk katalizatzailea",
  "block.minecraft.sculk_sensor": "Sculk sentsorea",
  "block.minecraft.sculk_shrieker": "Sculk oihukatzailea",
  "block.minecraft.sculk_vein": "Sculk zaina",
  "block.minecraft.sea_lantern": "Itsas linterna",
  "block.minecraft.sea_pickle": "Itsasoko eskabetxea",
  "block.minecraft.seagrass": "Itsas belarra",
  "block.minecraft.set_spawn": "Berragertze-puntua ezarri da",
  "block.minecraft.short_dry_grass": "Belar motz lehorra",
  "block.minecraft.short_grass": "Belar motza",
  "block.minecraft.shroomlight": "Argionddoa",
  "block.minecraft.shulker_box": "Shulker-kutxa",
  "block.minecraft.skeleton_skull": "Eskeleto-garezurra",
  "block.minecraft.skeleton_wall_skull": "Eskeleto-garezurra horman",
  "block.minecraft.slime_block": "Likati blokea",
  "block.minecraft.small_amethyst_bud": "Ametista ernamuin txikia",
  "block.minecraft.small_dripleaf": "Tanta-hosto txikia",
  "block.minecraft.smithing_table": "Errementari-mahaia",
  "block.minecraft.smoker": "Keztatzailea",
  "block.minecraft.smooth_basalt": "Basalto leuna",
  "block.minecraft.smooth_quartz": "Kuartzo leunezko blokea",
  "block.minecraft.smooth_quartz_slab": "Kuartzo leunezko lauza",
  "block.minecraft.smooth_quartz_stairs": "Kuartzo leunezko eskailerak",
  "block.minecraft.smooth_red_sandstone": "Hareharri gorri leuna",
  "block.minecraft.smooth_red_sandstone_slab": "Hareharri gorri leunezko lauza",
  "block.minecraft.smooth_red_sandstone_stairs": "Hareharri gorri leunezko eskailerak",
  "block.minecraft.smooth_sandstone": "Hareharri leuna",
  "block.minecraft.smooth_sandstone_slab": "Hareharri leunezko lauza",
  "block.minecraft.smooth_sandstone_stairs": "Hareharri leunezko eskailerak",
  "block.minecraft.smooth_stone": "Harri leuna",
  "block.minecraft.smooth_stone_slab": "Harri leunezko lauza",
  "block.minecraft.sniffer_egg": "Snifferren Arrautza",
  "block.minecraft.snow": "Elurra",
  "block.minecraft.snow_block": "Elur blokea",
  "block.minecraft.soul_campfire": "Arima-sutegia",
  "block.minecraft.soul_fire": "Arimetako sua",
  "block.minecraft.soul_lantern": "Arima linterna",
  "block.minecraft.soul_sand": "Arima harea",
  "block.minecraft.soul_soil": "Arima-lurra",
  "block.minecraft.soul_torch": "Arima-zuzia",
  "block.minecraft.soul_wall_torch": "Arima-zuzia horman",
  "block.minecraft.spawn.not_valid": "Ez duzu oherik edo berragertzeko loturarik ezarrita, edo buxatuta egon daitezke",
  "block.minecraft.spawner": "Munstro sortzailea",
  "block.minecraft.spawner.desc1": "Sortze-arrautzarekin elkarreragin:",
  "block.minecraft.spawner.desc2": "Izaki mota ipinitzen du",
  "block.minecraft.sponge": "Belakia",
  "block.minecraft.spore_blossom": "Espora-lorea",
  "block.minecraft.spruce_button": "Izeizko botoia",
  "block.minecraft.spruce_door": "Izeizko atea",
  "block.minecraft.spruce_fence": "Izeizko hesia",
  "block.minecraft.spruce_fence_gate": "Izeizko hesi atea",
  "block.minecraft.spruce_hanging_sign": "Izeizko kartel eskegia",
  "block.minecraft.spruce_leaves": "Izei hostoak",
  "block.minecraft.spruce_log": "Izei enborra",
  "block.minecraft.spruce_planks": "Izei oholak",
  "block.minecraft.spruce_pressure_plate": "Izeizko presio plaka",
  "block.minecraft.spruce_sapling": "Izei kimua",
  "block.minecraft.spruce_shelf": "Izeizko apala",
  "block.minecraft.spruce_sign": "Izeizko kartela",
  "block.minecraft.spruce_slab": "Izeizko lauza",
  "block.minecraft.spruce_stairs": "Izeizko eskailerak",
  "block.minecraft.spruce_trapdoor": "Izeizko tranpola",
  "block.minecraft.spruce_wall_hanging_sign": "Izeizko kartel eskegia horman",
  "block.minecraft.spruce_wall_sign": "Izeizko kartela horman",
  "block.minecraft.spruce_wood": "Izei egurra",
  "block.minecraft.sticky_piston": "Pistoi itsaskorra",
  "block.minecraft.stone": "Harria",
  "block.minecraft.stone_brick_slab": "Harrizko adreiluzko lauza",
  "block.minecraft.stone_brick_stairs": "Harrizko adreiluzko eskailerak",
  "block.minecraft.stone_brick_wall": "Harrizko adreiluzko horma",
  "block.minecraft.stone_bricks": "Harrizko adreiluak",
  "block.minecraft.stone_button": "Harrizko botoia",
  "block.minecraft.stone_pressure_plate": "Harrizko presio plaka",
  "block.minecraft.stone_slab": "Harrizko lauza",
  "block.minecraft.stone_stairs": "Harrizko eskailerak",
  "block.minecraft.stonecutter": "Harriamozgailua",
  "block.minecraft.stripped_acacia_log": "Azalik gabeko akazia enborra",
  "block.minecraft.stripped_acacia_wood": "Azalik gabeko akazia egurra",
  "block.minecraft.stripped_bamboo_block": "Banbuzko bloke zuritua",
  "block.minecraft.stripped_birch_log": "Azalik gabeko urki enborra",
  "block.minecraft.stripped_birch_wood": "Azalik gabeko urki egurra",
  "block.minecraft.stripped_cherry_log": "Azalik gabeko gereziondo enborra",
  "block.minecraft.stripped_cherry_wood": "Azalik gabeko gereziondo egurra",
  "block.minecraft.stripped_crimson_hyphae": "Azalik gabeko hifa gorrimina",
  "block.minecraft.stripped_crimson_stem": "Azalik gabeko zurtoin gorrimina",
  "block.minecraft.stripped_dark_oak_log": "Azalik gabeko haritz ilun enborra",
  "block.minecraft.stripped_dark_oak_wood": "Azalik gabeko haritz ilun egurra",
  "block.minecraft.stripped_jungle_log": "Azalik gabeko oihan enborra",
  "block.minecraft.stripped_jungle_wood": "Azalik gabeko oihan egurra",
  "block.minecraft.stripped_mangrove_log": "Azalik gabeko mangle emborra",
  "block.minecraft.stripped_mangrove_wood": "Azalik gabeko mangle egurra",
  "block.minecraft.stripped_oak_log": "Azalik gabeko haritz enborra",
  "block.minecraft.stripped_oak_wood": "Azalik gabeko haritz egurra",
  "block.minecraft.stripped_pale_oak_log": "Azalik gabeko haritz zurbil enborra",
  "block.minecraft.stripped_pale_oak_wood": "Azalik gabeko haritz zurbil egurra",
  "block.minecraft.stripped_spruce_log": "Azalik gabeko izei enborra",
  "block.minecraft.stripped_spruce_wood": "Azalik gabeko izei egurra",
  "block.minecraft.stripped_warped_hyphae": "Azalik gabeko hifa okertua",
  "block.minecraft.stripped_warped_stem": "Azalik gabeko zurtoin okertua",
  "block.minecraft.structure_block": "Egitura Blokea",
  "block.minecraft.structure_void": "Egitura Hutsunea",
  "block.minecraft.sugar_cane": "Azukre Kanabera",
  "block.minecraft.sunflower": "Eguzki-lorea",
  "block.minecraft.suspicious_gravel": "Legar susmagarria",
  "block.minecraft.suspicious_sand": "Hondar susmagarria",
  "block.minecraft.sweet_berry_bush": "Fruitu Gozosko zuhaixka",
  "block.minecraft.tall_dry_grass": "Belar luze lehorra",
  "block.minecraft.tall_grass": "Belar luzea",
  "block.minecraft.tall_seagrass": "Itsas-belar luzea",
  "block.minecraft.target": "Itua",
  "block.minecraft.terracotta": "Terrakota",
  "block.minecraft.test_block": "Proba blokea",
  "block.minecraft.test_instance_block": "Instantzia-proba blokea",
  "block.minecraft.tinted_glass": "Kristal tindatua",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "TNT leherketak desgaituta daude",
  "block.minecraft.torch": "Argi-zuzia",
  "block.minecraft.torchflower": "Lastargi-lorea",
  "block.minecraft.torchflower_crop": "Lastargi-lorezko uzta",
  "block.minecraft.trapped_chest": "Tranpadun kutxa",
  "block.minecraft.trial_spawner": "Erronka-sortzailea",
  "block.minecraft.tripwire": "Segada",
  "block.minecraft.tripwire_hook": "Segadaren lotura",
  "block.minecraft.tube_coral": "Hodizko korala",
  "block.minecraft.tube_coral_block": "Bizigabeko hodi koral blokea",
  "block.minecraft.tube_coral_fan": "Hodizko korala",
  "block.minecraft.tube_coral_wall_fan": "Hodi Koralaren horma-fan",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Tobazko adreiluzko lauza",
  "block.minecraft.tuff_brick_stairs": "Tobazko adreiluzko eskailerak",
  "block.minecraft.tuff_brick_wall": "Tobazko adreiluzko horma",
  "block.minecraft.tuff_bricks": "Tobazko adreiluak",
  "block.minecraft.tuff_slab": "Tobazko lauza",
  "block.minecraft.tuff_stairs": "Tobazko eskailerak",
  "block.minecraft.tuff_wall": "Tobazko horma",
  "block.minecraft.turtle_egg": "Dortoka-arrautza",
  "block.minecraft.twisting_vines": "Igokari okerra",
  "block.minecraft.twisting_vines_plant": "mahastien landarea bihurrituz",
  "block.minecraft.vault": "Kupela",
  "block.minecraft.verdant_froglight": "Igelargi berdea",
  "block.minecraft.vine": "Igokaria",
  "block.minecraft.void_air": "Hutseko airea",
  "block.minecraft.wall_torch": "Argi-zuzia horman",
  "block.minecraft.warped_button": "Botoi okertua",
  "block.minecraft.warped_door": "Ate okertua",
  "block.minecraft.warped_fence": "Hesi okertua",
  "block.minecraft.warped_fence_gate": "Hesi ate okertua",
  "block.minecraft.warped_fungus": "Onddo okertua",
  "block.minecraft.warped_hanging_sign": "Kartel eskegi okertua",
  "block.minecraft.warped_hyphae": "Hifa okertua",
  "block.minecraft.warped_nylium": "Nezelio okertua",
  "block.minecraft.warped_planks": "Ohol okertuak",
  "block.minecraft.warped_pressure_plate": "Presio plaka okertua",
  "block.minecraft.warped_roots": "Sustrai okertuak",
  "block.minecraft.warped_shelf": "Apal okertua",
  "block.minecraft.warped_sign": "Kartel okertua",
  "block.minecraft.warped_slab": "Lauza okertua",
  "block.minecraft.warped_stairs": "Eskailera okertuak",
  "block.minecraft.warped_stem": "Zurtoin okertua",
  "block.minecraft.warped_trapdoor": "Tranpola okertua",
  "block.minecraft.warped_wall_hanging_sign": "Kartel eskegi okertua horman",
  "block.minecraft.warped_wall_sign": "Kartel okertua horman",
  "block.minecraft.warped_wart_block": "Garatxo-bloke gaiztoa",
  "block.minecraft.water": "Ura",
  "block.minecraft.water_cauldron": "Ur galdara",
  "block.minecraft.waxed_chiseled_copper": "Ezkoztatutako kobre zizelkatua",
  "block.minecraft.waxed_copper_bars": "Ezkoztatutako kobrezko barrak",
  "block.minecraft.waxed_copper_block": "Ezkoztatutako kobrezko blokea",
  "block.minecraft.waxed_copper_bulb": "Ezkoztatutako kobrezko bonbilla",
  "block.minecraft.waxed_copper_chain": "Ezkoztatutako kobrezko katea",
  "block.minecraft.waxed_copper_chest": "Ezkoztatutako kobrezko kutxa",
  "block.minecraft.waxed_copper_door": "Ezkoztatutako kobrezko atea",
  "block.minecraft.waxed_copper_golem_statue": "Ezkoztatutako kobrezko golem estatua",
  "block.minecraft.waxed_copper_grate": "Ezkoztatutako kobrezko sareta",
  "block.minecraft.waxed_copper_lantern": "Ezkoztatutako kobrezko argiontzia",
  "block.minecraft.waxed_copper_trapdoor": "Ezkoztatutako kobrezko tranpola",
  "block.minecraft.waxed_cut_copper": "Ezkoztatutako moztutako kobrea",
  "block.minecraft.waxed_cut_copper_slab": "Ezkoztatutako moztutako kobrezko lauza",
  "block.minecraft.waxed_cut_copper_stairs": "Ezkoztatutako moztutako kobrezko eskailerak",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ezkoztatutako kobre estalgabetu zizelkatua",
  "block.minecraft.waxed_exposed_copper": "Ezkoztatutako kobre estalgabetua",
  "block.minecraft.waxed_exposed_copper_bars": "Ezkoztatutako kobrezko barra estalgabetuak",
  "block.minecraft.waxed_exposed_copper_bulb": "Ezkoztatutako kobrezko bonbilla estalgabetua",
  "block.minecraft.waxed_exposed_copper_chain": "Ezkoztatutako kobrezko kate estalgabetua",
  "block.minecraft.waxed_exposed_copper_chest": "Ezkoztatutako kobrezko kutxa estalgabetua",
  "block.minecraft.waxed_exposed_copper_door": "Ezkoztatutako kobrezko ate estalgabetua",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ezkoztatutako kobrezko golem estatua estalgabetua",
  "block.minecraft.waxed_exposed_copper_grate": "Ezkoztatutako kobrezko sareta estalgabetua",
  "block.minecraft.waxed_exposed_copper_lantern": "Ezkoztatutako kobrezko argiontzi estalgabetua",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ezkoztatutako kobrezko tranpol estalgabetua",
  "block.minecraft.waxed_exposed_cut_copper": "Ezkoztatutako moztutako kobre estalgabetua",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ezkoztatutako moztutako kobrezko lauza estalgabetua",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ezkoztatutako moztutako kobrezko eskailera estalgabetuak",
  "block.minecraft.waxed_exposed_lightning_rod": "Ezkoztatutako kobrezko tximistorratz estalgabetua",
  "block.minecraft.waxed_lightning_rod": "Ezkoztatutako kobrezko tximistorratza",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ezkoztatutako kobre herdoildu zizelkatua",
  "block.minecraft.waxed_oxidized_copper": "Ezkoztatutako kobre herdoildua",
  "block.minecraft.waxed_oxidized_copper_bars": "Ezkoztatutako kobrezko barra herdoilduak",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ezkoztatutako kobrezko bonbilla herdoildua",
  "block.minecraft.waxed_oxidized_copper_chain": "Ezkoztatutako kobrezko kate herdoildua",
  "block.minecraft.waxed_oxidized_copper_chest": "Ezkoztatutako kobrezko kutxa herdoildua",
  "block.minecraft.waxed_oxidized_copper_door": "Ezkoztatutako kobrezko ate herdoildua",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ezkoztatutako kobrezko golem estatua herdoildua",
  "block.minecraft.waxed_oxidized_copper_grate": "Ezkoztatutako kobrezko sareta herdoildua",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ezkoztatutako kobrezko argiontzi herdoildua",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ezkoztatutako kobrezko tranpol herdoildua",
  "block.minecraft.waxed_oxidized_cut_copper": "Ezkoztatutako moztutako kobre herdoildua",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ezkoztatutako moztutako kobrezko lauza herdoildua",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ezkoztatutako moztutako kobrezko eskailera herdoilduak",
  "block.minecraft.waxed_oxidized_lightning_rod": "Ezkoztatutako kobrezko tximistorratz herdoildua",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ezkoztatutako kobre degradatu zizelkatua",
  "block.minecraft.waxed_weathered_copper": "Ezkoztatutako kobre degradatua",
  "block.minecraft.waxed_weathered_copper_bars": "Ezkoztatutako kobrezko barra degradatuak",
  "block.minecraft.waxed_weathered_copper_bulb": "Ezkoztatutako kobrezko bonbilla degradatua",
  "block.minecraft.waxed_weathered_copper_chain": "Ezkoztatutako kobrezko kate degradatua",
  "block.minecraft.waxed_weathered_copper_chest": "Ezkoztatutako kobrezko kutxa degradatua",
  "block.minecraft.waxed_weathered_copper_door": "Ezkoztatutako kobrezko ate degradatua",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ezkoztatutako kobrezko golem estatua degradatua",
  "block.minecraft.waxed_weathered_copper_grate": "Ezkoztatutako kobrezko sareta degradatua",
  "block.minecraft.waxed_weathered_copper_lantern": "Ezkoztatutako kobrezko argiontzi degradatua",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ezkoztatutako kobrezko tranpol degradatua",
  "block.minecraft.waxed_weathered_cut_copper": "Ezkoztatutako moztutako kobre degradatua",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ezkoztatutako moztutako kobrezko lauza degradatua",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ezkoztatutako moztutako kobrezko eskailera degradatuak",
  "block.minecraft.waxed_weathered_lightning_rod": "Ezkoztatutako kobrezko tximistorratz degradatua",
  "block.minecraft.weathered_chiseled_copper": "Kobre degradatu zizelkatua",
  "block.minecraft.weathered_copper": "Kobre degradatua",
  "block.minecraft.weathered_copper_bars": "Kobrezko barra degradatuak",
  "block.minecraft.weathered_copper_bulb": "Kobrezko bonbilla degradatua",
  "block.minecraft.weathered_copper_chain": "Kobrezko kate degradatua",
  "block.minecraft.weathered_copper_chest": "Kobrezko kutxa degradatua",
  "block.minecraft.weathered_copper_door": "Kobrezko ate degradatua",
  "block.minecraft.weathered_copper_golem_statue": "Kobrezko golem estatua degradatua",
  "block.minecraft.weathered_copper_grate": "Kobrezko sareta degradatua",
  "block.minecraft.weathered_copper_lantern": "Kobrezko argiontzi degradatua",
  "block.minecraft.weathered_copper_trapdoor": "Kobrezko tranpol degradatua",
  "block.minecraft.weathered_cut_copper": "Moztutako kobre degradatua",
  "block.minecraft.weathered_cut_copper_slab": "Moztutako kobrezko lauza degradatua",
  "block.minecraft.weathered_cut_copper_stairs": "Moztutako kobrezko eskailera degradatuak",
  "block.minecraft.weathered_lightning_rod": "Kobrezko tximistorratz degradatua",
  "block.minecraft.weeping_vines": "Igokari negartiak",
  "block.minecraft.weeping_vines_plant": "mahatsondo negar landarea",
  "block.minecraft.wet_sponge": "Belaki bustia",
  "block.minecraft.wheat": "Gari uzta",
  "block.minecraft.white_banner": "Zutoihal zuria",
  "block.minecraft.white_bed": "Ohe Zuria",
  "block.minecraft.white_candle": "Kandela zuria",
  "block.minecraft.white_candle_cake": "Tarta kandela zuriarekin",
  "block.minecraft.white_carpet": "Alfonbra zuria",
  "block.minecraft.white_concrete": "Hormigoi Zuria",
  "block.minecraft.white_concrete_powder": "Zementu zuria",
  "block.minecraft.white_glazed_terracotta": "Terrakota beiraztatu zuria",
  "block.minecraft.white_shulker_box": "Shulker-kutxa zuria",
  "block.minecraft.white_stained_glass": "Kristal zuria",
  "block.minecraft.white_stained_glass_pane": "Kristalezko panel zuria",
  "block.minecraft.white_terracotta": "Terrakota zuria",
  "block.minecraft.white_tulip": "Tulipa zuria",
  "block.minecraft.white_wool": "Artile zuria",
  "block.minecraft.wildflowers": "Loretxo basatiak",
  "block.minecraft.wither_rose": "Wither arrosa",
  "block.minecraft.wither_skeleton_skull": "Wither eskeleto-garezurra",
  "block.minecraft.wither_skeleton_wall_skull": "Wither eskeleto-garezurra horman",
  "block.minecraft.yellow_banner": "Zutoihal horia",
  "block.minecraft.yellow_bed": "Ohe Horia",
  "block.minecraft.yellow_candle": "Kandela horia",
  "block.minecraft.yellow_candle_cake": "Tarta kandela horiarekin",
  "block.minecraft.yellow_carpet": "Hori koloreko alfonbra",
  "block.minecraft.yellow_concrete": "Hormigoi Horia",
  "block.minecraft.yellow_concrete_powder": "Zementu horia",
  "block.minecraft.yellow_glazed_terracotta": "Terrakota beiraztatu horia",
  "block.minecraft.yellow_shulker_box": "Shulker-kutxa horia",
  "block.minecraft.yellow_stained_glass": "Kristal horia",
  "block.minecraft.yellow_stained_glass_pane": "Kristalezko panel horia",
  "block.minecraft.yellow_terracotta": "Terrakota horia",
  "block.minecraft.yellow_wool": "Artile horia",
  "block.minecraft.zombie_head": "Zonbi-burua",
  "block.minecraft.zombie_wall_head": "Zonbi-burua paretan",
  "item.minecraft.acacia_boat": "Akaziazko txalupa",
  "item.minecraft.acacia_chest_boat": "Akaziazko txalupa kutxarekin",
  "item.minecraft.allay_spawn_egg": "Allay sortzaile arrautza",
  "item.minecraft.amethyst_shard": "Ametista puska",
  "item.minecraft.angler_pottery_shard": "Arrantzale zeramika-puska",
  "item.minecraft.angler_pottery_sherd": "Arrantzale zeramika-puska",
  "item.minecraft.apple": "Sagarra",
  "item.minecraft.archer_pottery_shard": "Arkulari zeramika-puska",
  "item.minecraft.archer_pottery_sherd": "Arkulari zeramika-puska",
  "item.minecraft.armadillo_scute": "Armadilo-ezkata",
  "item.minecraft.armadillo_spawn_egg": "Armadilo sortzaile arrautza",
  "item.minecraft.armor_stand": "Armadurarentzako euskarria",
  "item.minecraft.arms_up_pottery_shard": "Txotxongilo zeramika-puska",
  "item.minecraft.arms_up_pottery_sherd": "Txotxongilo zeramika-puska",
  "item.minecraft.arrow": "Gezia",
  "item.minecraft.axolotl_bucket": "Axolote ontziratua",
  "item.minecraft.axolotl_spawn_egg": "Axolote sortzaile arrautza",
  "item.minecraft.baked_potato": "Patata errea",
  "item.minecraft.bamboo_chest_raft": "Banbuzko baltsa kutxarekin",
  "item.minecraft.bamboo_raft": "Banbuzko baltsa",
  "item.minecraft.bat_spawn_egg": "Saguzar sortzaile arrautza",
  "item.minecraft.bee_spawn_egg": "Erle sortzaile arrautza",
  "item.minecraft.beef": "Txekor gordina",
  "item.minecraft.beetroot": "Erremolatxa",
  "item.minecraft.beetroot_seeds": "Erremolatxa-hazia",
  "item.minecraft.beetroot_soup": "Erremolatxa zopa",
  "item.minecraft.birch_boat": "Urkizko txalupa",
  "item.minecraft.birch_chest_boat": "Urkizko txalupa kutxarekin",
  "item.minecraft.black_bundle": "Zaku beltza",
  "item.minecraft.black_dye": "Tindagai beltza",
  "item.minecraft.black_harness": "Arnes beltza",
  "item.minecraft.blade_pottery_shard": "Ezpata zeramika-puska",
  "item.minecraft.blade_pottery_sherd": "Ezpata zeramika-puska",
  "item.minecraft.blaze_powder": "Sutzar-hautsa",
  "item.minecraft.blaze_rod": "Sutzar-hagaxka",
  "item.minecraft.blaze_spawn_egg": "Sutzar sortzaile arrautza",
  "item.minecraft.blue_bundle": "Zaku urdina",
  "item.minecraft.blue_dye": "Tindagai urdina",
  "item.minecraft.blue_egg": "Arrautza urdina",
  "item.minecraft.blue_harness": "Arnes urdina",
  "item.minecraft.bogged_spawn_egg": "Lokazti sortzaile arrautza",
  "item.minecraft.bolt_armor_trim_smithing_template": "Errementaritza-txantiloia",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Errematxe armadura-edergarria",
  "item.minecraft.bone": "Hezurra",
  "item.minecraft.bone_meal": "Hezur hautsa",
  "item.minecraft.book": "Liburua",
  "item.minecraft.bordure_indented_banner_pattern": "Koskadun ertz zutoihal-estanpatua",
  "item.minecraft.bow": "Arkua",
  "item.minecraft.bowl": "Katilua",
  "item.minecraft.bread": "Ogia",
  "item.minecraft.breeze_rod": "Haizete-hagaxka",
  "item.minecraft.breeze_spawn_egg": "Haizete sortzaile arrautza",
  "item.minecraft.brewer_pottery_shard": "Edabegile zeramika-puska",
  "item.minecraft.brewer_pottery_sherd": "Edabegile zeramika-puska",
  "item.minecraft.brewing_stand": "Edabe-mahaia",
  "item.minecraft.brick": "Adreilua",
  "item.minecraft.brown_bundle": "Zaku marroia",
  "item.minecraft.brown_dye": "Tindagai marroia",
  "item.minecraft.brown_egg": "Arrautza marroia",
  "item.minecraft.brown_harness": "Arnes marroia",
  "item.minecraft.brush": "Brotxa",
  "item.minecraft.bucket": "Ontzia",
  "item.minecraft.bundle": "Poltsa",
  "item.minecraft.bundle.empty": "Hutsik",
  "item.minecraft.bundle.empty.description": "Objektu mota ugari jaso ditzake stack batera arte",
  "item.minecraft.bundle.full": "Beteta",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Su zeramika-puska",
  "item.minecraft.burn_pottery_sherd": "Su zeramika-puska",
  "item.minecraft.camel_husk_spawn_egg": "Gamelu momifikatu sortzaile arrautza",
  "item.minecraft.camel_spawn_egg": "Gamelu sortzaile arrautza",
  "item.minecraft.carrot": "Azenarioa",
  "item.minecraft.carrot_on_a_stick": "Azenarioa makila batekin",
  "item.minecraft.cat_spawn_egg": "Katu sortzaile arrautza",
  "item.minecraft.cauldron": "Galdara",
  "item.minecraft.cave_spider_spawn_egg": "Kobazuloetako armiarma sortzaile arrautza",
  "item.minecraft.chainmail_boots": "Kotazko botak",
  "item.minecraft.chainmail_chestplate": "Kotazko bular-oskola",
  "item.minecraft.chainmail_helmet": "Kotazko kaskoa",
  "item.minecraft.chainmail_leggings": "Kotazko zangoak",
  "item.minecraft.charcoal": "Egur-ikatza",
  "item.minecraft.cherry_boat": "Gereziondozko txalupa",
  "item.minecraft.cherry_chest_boat": "Gereziondozko txalupa kutxarekin",
  "item.minecraft.chest_minecart": "Bagoneta kutxarekin",
  "item.minecraft.chicken": "Oilasko gordina",
  "item.minecraft.chicken_spawn_egg": "Oilo sortzaile arrautza",
  "item.minecraft.chorus_fruit": "Koral fruta",
  "item.minecraft.clay_ball": "Buztinezko bola",
  "item.minecraft.clock": "Erlojua",
  "item.minecraft.coal": "Ikatza",
  "item.minecraft.coast_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Itsasertz armadura-edergarria",
  "item.minecraft.cocoa_beans": "Kakao aleak",
  "item.minecraft.cod": "Bakailao gordina",
  "item.minecraft.cod_bucket": "Bakailao ontziratua",
  "item.minecraft.cod_spawn_egg": "Bakailao sortzaile arrautza",
  "item.minecraft.command_block_minecart": "Bagoneta komando blokearekin",
  "item.minecraft.compass": "Iparrorratza",
  "item.minecraft.cooked_beef": "Xerra",
  "item.minecraft.cooked_chicken": "Oilasko errea",
  "item.minecraft.cooked_cod": "Bakailao errea",
  "item.minecraft.cooked_mutton": "Bildots errea",
  "item.minecraft.cooked_porkchop": "Txerri txuleta errea",
  "item.minecraft.cooked_rabbit": "Untxi errea",
  "item.minecraft.cooked_salmon": "Izokin errea",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Kobrezko aizkora",
  "item.minecraft.copper_boots": "Kobrezko botak",
  "item.minecraft.copper_chestplate": "Kobrezko bular-oskola",
  "item.minecraft.copper_golem_spawn_egg": "Kobrezko golem sortzaile arrautza",
  "item.minecraft.copper_helmet": "Kobrezko kaskoa",
  "item.minecraft.copper_hoe": "Kobrezko aitzurra",
  "item.minecraft.copper_horse_armor": "Kobrezko zaldi-armadura",
  "item.minecraft.copper_ingot": "Kobrezko lingotea",
  "item.minecraft.copper_leggings": "Kobrezko zangoak",
  "item.minecraft.copper_nautilus_armor": "Kobrezko nautilus-armadura",
  "item.minecraft.copper_nugget": "Kobrezko pipita",
  "item.minecraft.copper_pickaxe": "Kobrezko pikotxa",
  "item.minecraft.copper_shovel": "Kobrezko pala",
  "item.minecraft.copper_spear": "Kobrezko lantza",
  "item.minecraft.copper_sword": "Kobrezko ezpata",
  "item.minecraft.cow_spawn_egg": "Behi sortzaile arrautza",
  "item.minecraft.creaking_spawn_egg": "Karrankari sortzaile arrautza",
  "item.minecraft.creeper_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper karga",
  "item.minecraft.creeper_banner_pattern.new": "Creeper karga zutoihal-estanpatua",
  "item.minecraft.creeper_spawn_egg": "Creeper sortzaile arrautza",
  "item.minecraft.crossbow": "Balezta",
  "item.minecraft.crossbow.projectile": "Jaurtigaia:",
  "item.minecraft.crossbow.projectile.multiple": "Jaurtigaia: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Jaurtigaia: %s",
  "item.minecraft.cyan_bundle": "Zaku ziana",
  "item.minecraft.cyan_dye": "Zian koloreko tindagaia",
  "item.minecraft.cyan_harness": "Arnes ziana",
  "item.minecraft.danger_pottery_shard": "Arrisku zeramika-puska",
  "item.minecraft.danger_pottery_sherd": "Arrisku zeramika-puska",
  "item.minecraft.dark_oak_boat": "Haritz ilunezko txalupa",
  "item.minecraft.dark_oak_chest_boat": "Haritz ilunezko txalupa kutxarekin",
  "item.minecraft.debug_stick": "Garatzaile makila",
  "item.minecraft.debug_stick.empty": "%s-ek ez dauka propietaterik",
  "item.minecraft.debug_stick.select": "hautatutako \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" %s(e)ra",
  "item.minecraft.diamond": "Diamantea",
  "item.minecraft.diamond_axe": "Diamantezko aizkora",
  "item.minecraft.diamond_boots": "Diamantezko botak",
  "item.minecraft.diamond_chestplate": "Diamantezko bular-oskola",
  "item.minecraft.diamond_helmet": "Diamantezko kaskoa",
  "item.minecraft.diamond_hoe": "Diamantezko aitzurra",
  "item.minecraft.diamond_horse_armor": "Diamantezko zaldi-armadura",
  "item.minecraft.diamond_leggings": "Diamantezko zangoak",
  "item.minecraft.diamond_nautilus_armor": "Diamantezko nautilus-armadura",
  "item.minecraft.diamond_pickaxe": "Diamantezko pikotxa",
  "item.minecraft.diamond_shovel": "Diamantezko pala",
  "item.minecraft.diamond_spear": "Diamantezko lantza",
  "item.minecraft.diamond_sword": "Diamantezko ezpata",
  "item.minecraft.disc_fragment_5": "Disko puska",
  "item.minecraft.disc_fragment_5.desc": "Musika diskoa - 5",
  "item.minecraft.dolphin_spawn_egg": "Izurde sortzaile arrautza",
  "item.minecraft.donkey_spawn_egg": "Asto sortzaile arrautza",
  "item.minecraft.dragon_breath": "Dragoiaren hatsa",
  "item.minecraft.dried_kelp": "Lehortutako algak",
  "item.minecraft.drowned_spawn_egg": "Ito sortzaile arrautza",
  "item.minecraft.dune_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Duna armadura-edergarria",
  "item.minecraft.echo_shard": "Oihartzun puska",
  "item.minecraft.egg": "Arrautza",
  "item.minecraft.elder_guardian_spawn_egg": "Zaindari nagusi sortzaile arrautza",
  "item.minecraft.elytra": "Elitroak",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Sorgindutako liburua",
  "item.minecraft.enchanted_golden_apple": "Sorgindutako urrezko sagarra",
  "item.minecraft.end_crystal": "Amaierako Kristala",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragoi sortzaile arrautza",
  "item.minecraft.ender_eye": "Ender begia",
  "item.minecraft.ender_pearl": "Ender perla",
  "item.minecraft.enderman_spawn_egg": "Enderman sortzaile arrautza",
  "item.minecraft.endermite_spawn_egg": "Endermite sortzaile arrautza",
  "item.minecraft.evoker_spawn_egg": "Inbokatzaile sortzaile arrautza",
  "item.minecraft.experience_bottle": "Sorginkeri botila",
  "item.minecraft.explorer_pottery_shard": "Esploratzaile zeramika-puska",
  "item.minecraft.explorer_pottery_sherd": "Esploratzaile zeramika-puska",
  "item.minecraft.eye_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Begi armadura-edergarria",
  "item.minecraft.feather": "Luma",
  "item.minecraft.fermented_spider_eye": "Legamiatutako armiarma begiak",
  "item.minecraft.field_masoned_banner_pattern": "Harlanduzko hondo zutoihal-estanpatua",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Su-bola",
  "item.minecraft.firework_rocket": "Suziria",
  "item.minecraft.firework_rocket.flight": "Hegaldi Iraupena:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Suziri izarra",
  "item.minecraft.firework_star.black": "Beltza",
  "item.minecraft.firework_star.blue": "Urdina",
  "item.minecraft.firework_star.brown": "Marroia",
  "item.minecraft.firework_star.custom_color": "Pertsonalizatua",
  "item.minecraft.firework_star.cyan": "Zian",
  "item.minecraft.firework_star.fade_to": "Aldatu",
  "item.minecraft.firework_star.flicker": "Dirdira",
  "item.minecraft.firework_star.gray": "Grisa",
  "item.minecraft.firework_star.green": "Berdea",
  "item.minecraft.firework_star.light_blue": "Urdin argia",
  "item.minecraft.firework_star.light_gray": "Gris argia",
  "item.minecraft.firework_star.lime": "Lima",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Laranja",
  "item.minecraft.firework_star.pink": "Arrosa",
  "item.minecraft.firework_star.purple": "Morea",
  "item.minecraft.firework_star.red": "Gorria",
  "item.minecraft.firework_star.shape": "Forma ezezaguna",
  "item.minecraft.firework_star.shape.burst": "Eztanda",
  "item.minecraft.firework_star.shape.creeper": "Creeper formarekin",
  "item.minecraft.firework_star.shape.large_ball": "Bola handia",
  "item.minecraft.firework_star.shape.small_ball": "Bola txikia",
  "item.minecraft.firework_star.shape.star": "Izar-formarekin",
  "item.minecraft.firework_star.trail": "Arrasto",
  "item.minecraft.firework_star.white": "Zuria",
  "item.minecraft.firework_star.yellow": "Horia",
  "item.minecraft.fishing_rod": "Arrantzarako kanabera",
  "item.minecraft.flint": "Suharria",
  "item.minecraft.flint_and_steel": "Suharria eta burdina",
  "item.minecraft.flow_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluxu armadura-edergarria",
  "item.minecraft.flow_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.flow_banner_pattern.desc": "Fluxu irudia",
  "item.minecraft.flow_banner_pattern.new": "Fluxu zutoihal-estanpatua",
  "item.minecraft.flow_pottery_sherd": "Espiraldun zeramika-puska",
  "item.minecraft.flower_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.flower_banner_pattern.desc": "Lore karga",
  "item.minecraft.flower_banner_pattern.new": "Lore karga zutoihal-estanpatua",
  "item.minecraft.flower_pot": "Loreontzia",
  "item.minecraft.fox_spawn_egg": "Azeri sortzaile arrautza",
  "item.minecraft.friend_pottery_shard": "Lagun zeramika-puska",
  "item.minecraft.friend_pottery_sherd": "Lagun zeramika-puska",
  "item.minecraft.frog_spawn_egg": "Igel sortzaile arrautza",
  "item.minecraft.furnace_minecart": "Bagoneta labearekin",
  "item.minecraft.ghast_spawn_egg": "Ghast sortzaile arrautza",
  "item.minecraft.ghast_tear": "Ghast malkoa",
  "item.minecraft.glass_bottle": "Kristalezko botila",
  "item.minecraft.glistering_melon_slice": "Meloi distiratsu zatia",
  "item.minecraft.globe_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.globe_banner_pattern.desc": "Planeta irudia",
  "item.minecraft.globe_banner_pattern.new": "Planeta zutoihal-estanpatua",
  "item.minecraft.glow_berries": "Fruitu Distiratsuak",
  "item.minecraft.glow_ink_sac": "Tinta distiratsu zakua",
  "item.minecraft.glow_item_frame": "Marko disdiratsua",
  "item.minecraft.glow_squid_spawn_egg": "Txibia disdiratsu sortzaile arrautza",
  "item.minecraft.glowstone_dust": "Argi-harriaren hautsa",
  "item.minecraft.goat_horn": "Ahuntz adarra",
  "item.minecraft.goat_spawn_egg": "Ahuntz sortzaile arrautza",
  "item.minecraft.gold_ingot": "Urrezko lingotea",
  "item.minecraft.gold_nugget": "Urrezko pipita",
  "item.minecraft.golden_apple": "Urrezko sagarra",
  "item.minecraft.golden_axe": "Urrezko aizkora",
  "item.minecraft.golden_boots": "Urrezko botak",
  "item.minecraft.golden_carrot": "Urrezko azenarioa",
  "item.minecraft.golden_chestplate": "Urrezko bular-oskola",
  "item.minecraft.golden_helmet": "Urrezko kaskoa",
  "item.minecraft.golden_hoe": "Urrezko aitzurra",
  "item.minecraft.golden_horse_armor": "Urrezko zaldi-armadura",
  "item.minecraft.golden_leggings": "Urrezko zangoak",
  "item.minecraft.golden_nautilus_armor": "Urrezko nautilus-armadura",
  "item.minecraft.golden_pickaxe": "Urrezko pikotxa",
  "item.minecraft.golden_shovel": "Urrezko pala",
  "item.minecraft.golden_spear": "Urrezko lantza",
  "item.minecraft.golden_sword": "Urrezko ezpata",
  "item.minecraft.gray_bundle": "Zaku grisa",
  "item.minecraft.gray_dye": "Tindagai grisa",
  "item.minecraft.gray_harness": "Arnes grisa",
  "item.minecraft.green_bundle": "Zaku berdea",
  "item.minecraft.green_dye": "Tindagai berdea",
  "item.minecraft.green_harness": "Arnes berdea",
  "item.minecraft.guardian_spawn_egg": "Zaindari sortzaile arrautza",
  "item.minecraft.gunpowder": "Bolbora",
  "item.minecraft.guster_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.guster_banner_pattern.desc": "Haizete irudia",
  "item.minecraft.guster_banner_pattern.new": "Haizete zutoihal-estanpatua",
  "item.minecraft.guster_pottery_sherd": "Haizete zeramika-puska",
  "item.minecraft.happy_ghast_spawn_egg": "Ghast alai sortzaile arrautza",
  "item.minecraft.harness": "Arnesa",
  "item.minecraft.heart_of_the_sea": "Itsasoaren bihotza",
  "item.minecraft.heart_pottery_shard": "Bihotz zeramika-puska",
  "item.minecraft.heart_pottery_sherd": "Bihotz zeramika-puska",
  "item.minecraft.heartbreak_pottery_shard": "Bihotz-haustura zeramika-puska",
  "item.minecraft.heartbreak_pottery_sherd": "Bihotz-haustura zeramika-puska",
  "item.minecraft.hoglin_spawn_egg": "Hoglin sortzaile arrautza",
  "item.minecraft.honey_bottle": "Botila bat ezti",
  "item.minecraft.honeycomb": "Eztiorrazi",
  "item.minecraft.hopper_minecart": "Bagoneta toberarekin",
  "item.minecraft.horse_spawn_egg": "Zaldi sortzaile arrautza",
  "item.minecraft.host_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ostalari armadura-edergarria",
  "item.minecraft.howl_pottery_shard": "Oihartzun zeramika-puska",
  "item.minecraft.howl_pottery_sherd": "Oihartzun zeramika-puska",
  "item.minecraft.husk_spawn_egg": "Zonbie momifikatu sortzaile arrautza",
  "item.minecraft.ink_sac": "Tinta zakua",
  "item.minecraft.iron_axe": "Burdinazko aizkora",
  "item.minecraft.iron_boots": "Burdinazko botak",
  "item.minecraft.iron_chestplate": "Burdinazko bular-oskola",
  "item.minecraft.iron_golem_spawn_egg": "Burdinazko golem sortzaile arrautza",
  "item.minecraft.iron_helmet": "Burdinazko kaskoa",
  "item.minecraft.iron_hoe": "Burdinazko aitzurra",
  "item.minecraft.iron_horse_armor": "Burdinazko zaldi-armadura",
  "item.minecraft.iron_ingot": "Burdinazko lingotea",
  "item.minecraft.iron_leggings": "Burdinazko zangoak",
  "item.minecraft.iron_nautilus_armor": "Burdinazko nautilus-armadura",
  "item.minecraft.iron_nugget": "Burdinazko pipita",
  "item.minecraft.iron_pickaxe": "Burdinazko pikotxa",
  "item.minecraft.iron_shovel": "Burdinazko pala",
  "item.minecraft.iron_spear": "Burdinazko lantza",
  "item.minecraft.iron_sword": "Burdinazko ezpata",
  "item.minecraft.item_frame": "Markoa",
  "item.minecraft.jungle_boat": "Oihanezko txalupa",
  "item.minecraft.jungle_chest_boat": "Oihanezko txalupa kutxarekin",
  "item.minecraft.knowledge_book": "Entziklopedia",
  "item.minecraft.lapis_lazuli": "Lapis lazulia",
  "item.minecraft.lava_bucket": "Laba ontzia",
  "item.minecraft.lead": "Soka",
  "item.minecraft.leather": "Larrua",
  "item.minecraft.leather_boots": "Larruzko botak",
  "item.minecraft.leather_chestplate": "Larruzko tunika",
  "item.minecraft.leather_helmet": "Larruzko txapela",
  "item.minecraft.leather_horse_armor": "Larruzko zaldi-armadura",
  "item.minecraft.leather_leggings": "Larruzko galtzak",
  "item.minecraft.light_blue_bundle": "Zaku urdin argia",
  "item.minecraft.light_blue_dye": "Tindagai urdin argia",
  "item.minecraft.light_blue_harness": "Arnes urdin argia",
  "item.minecraft.light_gray_bundle": "Zaku gris argia",
  "item.minecraft.light_gray_dye": "Tindagai gris argia",
  "item.minecraft.light_gray_harness": "Arnes gris argia",
  "item.minecraft.lime_bundle": "Zaku lima",
  "item.minecraft.lime_dye": "Lima koloreko tindagaia",
  "item.minecraft.lime_harness": "Arnes lima",
  "item.minecraft.lingering_potion": "Edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.awkward": "Edabe misteriotsu iraunkorra",
  "item.minecraft.lingering_potion.effect.empty": "Edabe ezezagun iraunkorra",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Suaren aurkako edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.harming": "Min egiteko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.healing": "Sendatzeko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.infested": "Infestazioko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.invisibility": "Ikusezintasuneko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.leaping": "Jauzi egiteko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.levitation": "Lebitazioko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.luck": "Zortezko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.mundane": "Edabe arrunt iraunkorra",
  "item.minecraft.lingering_potion.effect.night_vision": "Gaueko ikusmeneko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.oozing": "Lohitzeko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.poison": "Pozoitzeko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.regeneration": "Birsorkuntzako edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.slow_falling": "Erorketa geldoko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.slowness": "Geldotasuneko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.strength": "Indartzeko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.swiftness": "Azkartasuneko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.thick": "Edabe lodi iraunkor jaurtigarria",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dortoka maisuaren edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.water": "Ur botila iraunkorra",
  "item.minecraft.lingering_potion.effect.water_breathing": "Urpean arnasteko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.weakness": "Ahultzeko edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.weaving": "Ehungintza astunaren edabe iraunkorra",
  "item.minecraft.lingering_potion.effect.wind_charged": "Haize-boladazko edabe iraunkorra",
  "item.minecraft.llama_spawn_egg": "Llama sortzaile arrautza",
  "item.minecraft.lodestone_compass": "harrizko iparrorratza",
  "item.minecraft.mace": "Mailua",
  "item.minecraft.magenta_bundle": "Zaku magenta",
  "item.minecraft.magenta_dye": "Tindagai magenta",
  "item.minecraft.magenta_harness": "Arnes magenta",
  "item.minecraft.magma_cream": "Magma krema",
  "item.minecraft.magma_cube_spawn_egg": "Magma kubo sortzaile arrautza",
  "item.minecraft.mangrove_boat": "Manglezko txalupa",
  "item.minecraft.mangrove_chest_boat": "Manglezko txalupa kutxarekin",
  "item.minecraft.map": "Mapa hutsa",
  "item.minecraft.melon_seeds": "Meloiaren haziak",
  "item.minecraft.melon_slice": "Meloi zatia",
  "item.minecraft.milk_bucket": "Esnea Ontzia",
  "item.minecraft.minecart": "Bagoneta",
  "item.minecraft.miner_pottery_shard": "Meatzari zeramika-puska",
  "item.minecraft.miner_pottery_sherd": "Meatzari zeramika-puska",
  "item.minecraft.mojang_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.mojang_banner_pattern.desc": "Gauza irudia (Mojang)",
  "item.minecraft.mojang_banner_pattern.new": "Gauza zutoihal-estanpatua",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom sortzaile arrautza",
  "item.minecraft.mourner_pottery_shard": "Negarti zeramika-puska",
  "item.minecraft.mourner_pottery_sherd": "Negarti zeramika-puska",
  "item.minecraft.mule_spawn_egg": "Mando sortzaile arrautza",
  "item.minecraft.mushroom_stew": "Perretxiko erregosia",
  "item.minecraft.music_disc_11": "Musika diskoa",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musika diskoa",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musika diskoa",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musika diskoa",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musika diskoa",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musika diskoa",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musika diskoa",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Musika diskoa",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Musika diskoa",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musika diskoa",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musika diskoa",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musika diskoa",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musika diskoa",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musika diskoa",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musika diskoa",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Musika diskoa",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Musika diskoa",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musika diskoa",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musika diskoa",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musika diskoa",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musika diskoa",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Bildots gordina",
  "item.minecraft.name_tag": "Izen etiketa",
  "item.minecraft.nautilus_shell": "Nautilus oskola",
  "item.minecraft.nautilus_spawn_egg": "Nautilus sortzaile arrautza",
  "item.minecraft.nether_brick": "Netherreko adreilua",
  "item.minecraft.nether_star": "Netherreko izarra",
  "item.minecraft.nether_wart": "Azpimunduko garatxoa",
  "item.minecraft.netherite_axe": "Netheritazko aizkora",
  "item.minecraft.netherite_boots": "Netheritazko botak",
  "item.minecraft.netherite_chestplate": "Netheritazko bular-oskola",
  "item.minecraft.netherite_helmet": "Netheritazko kaskoa",
  "item.minecraft.netherite_hoe": "Netheritazko aitzurra",
  "item.minecraft.netherite_horse_armor": "Netheritazko zldi-armadura",
  "item.minecraft.netherite_ingot": "Netheritazko lingotea",
  "item.minecraft.netherite_leggings": "Netheritazko zangoak",
  "item.minecraft.netherite_nautilus_armor": "Netheritazko nautilus-armadura",
  "item.minecraft.netherite_pickaxe": "Netheritazko pikotxa",
  "item.minecraft.netherite_scrap": "Netheritazko puskak",
  "item.minecraft.netherite_shovel": "Netheritazko pala",
  "item.minecraft.netherite_spear": "Netheritazko lantza",
  "item.minecraft.netherite_sword": "Netheritazko ezpata",
  "item.minecraft.netherite_upgrade_smithing_template": "Errementaritza-txantiloia",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherita hobekuntza",
  "item.minecraft.oak_boat": "Haritzezko txalupa",
  "item.minecraft.oak_chest_boat": "Haritzezko txalupa kutxarekin",
  "item.minecraft.ocelot_spawn_egg": "Ozelote sortzaile arrautza",
  "item.minecraft.ominous_bottle": "Zorigaiztoko botila",
  "item.minecraft.ominous_trial_key": "Zorigaiztoko erronka-giltza",
  "item.minecraft.orange_bundle": "Zaku laranja",
  "item.minecraft.orange_dye": "Tindagai laranja",
  "item.minecraft.orange_harness": "Arnes laranja",
  "item.minecraft.painting": "Margolana",
  "item.minecraft.pale_oak_boat": "Haritz zurbilezko txalupa",
  "item.minecraft.pale_oak_chest_boat": "Haritz zurbilezko txalupa kutxarekin",
  "item.minecraft.panda_spawn_egg": "Panda sortzaile arrautza",
  "item.minecraft.paper": "Papera",
  "item.minecraft.parched_spawn_egg": "Idorreko sortzaile arrautza",
  "item.minecraft.parrot_spawn_egg": "Loro sortzaile arrautza",
  "item.minecraft.phantom_membrane": "Mamu-mintza",
  "item.minecraft.phantom_spawn_egg": "Mamu sortzaile arrautza",
  "item.minecraft.pig_spawn_egg": "Txerri sortzaile arrautza",
  "item.minecraft.piglin_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.piglin_banner_pattern.desc": "Mutur irudia",
  "item.minecraft.piglin_banner_pattern.new": "Mutur zutoihal-estanpatua",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin bortitz sortzaile arrautza",
  "item.minecraft.piglin_spawn_egg": "Piglin sortzaile arrautza",
  "item.minecraft.pillager_spawn_egg": "Arpilatzaile sortzaile arrautza",
  "item.minecraft.pink_bundle": "Zaku arrosa",
  "item.minecraft.pink_dye": "Tindagai arrosa",
  "item.minecraft.pink_harness": "Arnes arrosa",
  "item.minecraft.pitcher_plant": "Pitxer landarea",
  "item.minecraft.pitcher_pod": "Pitxer landare hazia",
  "item.minecraft.plenty_pottery_shard": "Amaigabetasun zeramika-puska",
  "item.minecraft.plenty_pottery_sherd": "Amaigabetasun zeramika-puska",
  "item.minecraft.poisonous_potato": "Patata pozoitsua",
  "item.minecraft.polar_bear_spawn_egg": "Hartz polar sortzaile arrautza",
  "item.minecraft.popped_chorus_fruit": "Koral fruta errea",
  "item.minecraft.porkchop": "Txerri txuleta gordina",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Edabea",
  "item.minecraft.potion.effect.awkward": "Edabe misteriotsua",
  "item.minecraft.potion.effect.empty": "Edabe eginezina",
  "item.minecraft.potion.effect.fire_resistance": "Suaren aurkako edabea",
  "item.minecraft.potion.effect.harming": "Min egiteko edabea",
  "item.minecraft.potion.effect.healing": "Sendatzeko edabea",
  "item.minecraft.potion.effect.infested": "Infestazioko edabea",
  "item.minecraft.potion.effect.invisibility": "Ikusezintasuneko edabea",
  "item.minecraft.potion.effect.leaping": "Jauzi egiteko edabea",
  "item.minecraft.potion.effect.levitation": "Lebitazioko edabea",
  "item.minecraft.potion.effect.luck": "Zortezko edabea",
  "item.minecraft.potion.effect.mundane": "Edabe arrunta",
  "item.minecraft.potion.effect.night_vision": "Gaueko ikusmeneko edabea",
  "item.minecraft.potion.effect.oozing": "Lohitzeko edabea",
  "item.minecraft.potion.effect.poison": "Pozoitzeko edabea",
  "item.minecraft.potion.effect.regeneration": "Birsorkuntzako edabea",
  "item.minecraft.potion.effect.slow_falling": "Erorketa geldoko edabea",
  "item.minecraft.potion.effect.slowness": "Geldotasuneko edabea",
  "item.minecraft.potion.effect.strength": "Indartzeko edabea",
  "item.minecraft.potion.effect.swiftness": "Azkartasuneko edabea",
  "item.minecraft.potion.effect.thick": "Edabe mamitsua",
  "item.minecraft.potion.effect.turtle_master": "Dortoka maisuaren edabea",
  "item.minecraft.potion.effect.water": "Botila bat ur",
  "item.minecraft.potion.effect.water_breathing": "Urpean arnasteko edabea",
  "item.minecraft.potion.effect.weakness": "Ahultzeko edabea",
  "item.minecraft.potion.effect.weaving": "Ehungintza astunaren edabea",
  "item.minecraft.potion.effect.wind_charged": "Haize-boladazko edabea",
  "item.minecraft.pottery_shard_archer": "Arkulariaren zeramika-zatia",
  "item.minecraft.pottery_shard_arms_up": "Besoak gora zeramika-zatia",
  "item.minecraft.pottery_shard_prize": "Sari zeramika-puska",
  "item.minecraft.pottery_shard_skull": "Garezur zeramika-puska",
  "item.minecraft.powder_snow_bucket": "Elur-hauts ontzia",
  "item.minecraft.prismarine_crystals": "Prismarina-kristalak",
  "item.minecraft.prismarine_shard": "Prismarina-puska",
  "item.minecraft.prize_pottery_shard": "Sari zeramika-puska",
  "item.minecraft.prize_pottery_sherd": "Sari zeramika-puska",
  "item.minecraft.pufferfish": "Globo-arraina",
  "item.minecraft.pufferfish_bucket": "Globo-arrain ontziratua",
  "item.minecraft.pufferfish_spawn_egg": "Globo-arrain sortzaile arrautza",
  "item.minecraft.pumpkin_pie": "Kalabaza pastela",
  "item.minecraft.pumpkin_seeds": "Kalabaza-haziak",
  "item.minecraft.purple_bundle": "Zaku morea",
  "item.minecraft.purple_dye": "Tindagai morea",
  "item.minecraft.purple_harness": "Arnes morea",
  "item.minecraft.quartz": "Netherreko kuartzoa",
  "item.minecraft.rabbit": "Untxi gordina",
  "item.minecraft.rabbit_foot": "Untxi hanka",
  "item.minecraft.rabbit_hide": "Untxi-larrua",
  "item.minecraft.rabbit_spawn_egg": "Untxi sortzaile arrautza",
  "item.minecraft.rabbit_stew": "Untxi erregosia",
  "item.minecraft.raiser_armor_trim_smithing_template": "Errementaritza-txantiloia",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Igotze armadura-edergarria",
  "item.minecraft.ravager_spawn_egg": "Suntsitzaile sortzaile arrautza",
  "item.minecraft.raw_copper": "Kobre landugabea",
  "item.minecraft.raw_gold": "Urre landugabea",
  "item.minecraft.raw_iron": "Burdina landugabea",
  "item.minecraft.recovery_compass": "Berreskuratze-iparrorratza",
  "item.minecraft.red_bundle": "Zaku gorria",
  "item.minecraft.red_dye": "Tindagai gorria",
  "item.minecraft.red_harness": "Arnes gorria",
  "item.minecraft.redstone": "Redstone-hautsa",
  "item.minecraft.resin_brick": "Erretxina adreilua",
  "item.minecraft.resin_clump": "Erretxina mamitsua",
  "item.minecraft.rib_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Saihets-hezur armadura-edergarria",
  "item.minecraft.rotten_flesh": "Haragi usteldua",
  "item.minecraft.saddle": "Zaltokia",
  "item.minecraft.salmon": "Izokin gordina",
  "item.minecraft.salmon_bucket": "Izokin ontziratua",
  "item.minecraft.salmon_spawn_egg": "Izokin sortzaile arrautza",
  "item.minecraft.scrape_pottery_sherd": "Aizkora zeramika-puska",
  "item.minecraft.scute": "Ezkata",
  "item.minecraft.sentry_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Zaindari armadura-edergarria",
  "item.minecraft.shaper_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Moldeatzaile armadura-edergarria",
  "item.minecraft.sheaf_pottery_shard": "Altxor zeramika-puska",
  "item.minecraft.sheaf_pottery_sherd": "Altxor zeramika-puska",
  "item.minecraft.shears": "Guraizeak",
  "item.minecraft.sheep_spawn_egg": "Ardi sortzaile arrautza",
  "item.minecraft.shelter_pottery_shard": "Aterpe zeramika-puska",
  "item.minecraft.shelter_pottery_sherd": "Aterpe zeramika-puska",
  "item.minecraft.shield": "Ezkutua",
  "item.minecraft.shield.black": "Ezkutu beltza",
  "item.minecraft.shield.blue": "Ezkutu urdina",
  "item.minecraft.shield.brown": "Ezkutu marroia",
  "item.minecraft.shield.cyan": "Zian koloreko ezkutua",
  "item.minecraft.shield.gray": "Ezkutu grisa",
  "item.minecraft.shield.green": "Ezkutu berdea",
  "item.minecraft.shield.light_blue": "Ezkutu urdin argia",
  "item.minecraft.shield.light_gray": "Ezkutu gris argia",
  "item.minecraft.shield.lime": "Lima koloreko ezkutua",
  "item.minecraft.shield.magenta": "Ezkutu magenta",
  "item.minecraft.shield.orange": "Ezkutu laranja",
  "item.minecraft.shield.pink": "Ezkutu arroxa",
  "item.minecraft.shield.purple": "Ezkutu morea",
  "item.minecraft.shield.red": "Ezkutu gorria",
  "item.minecraft.shield.white": "Ezkutu zuria",
  "item.minecraft.shield.yellow": "Ezkutu horia",
  "item.minecraft.shulker_shell": "Shulker oskola",
  "item.minecraft.shulker_spawn_egg": "Shulker sortzaile arrautza",
  "item.minecraft.sign": "Kartela",
  "item.minecraft.silence_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Isiltasun armadura-edergarria",
  "item.minecraft.silverfish_spawn_egg": "Zilar-arrain sortzaile arrautza",
  "item.minecraft.skeleton_horse_spawn_egg": "Eskeleto-zaldi sortzaile arrautza",
  "item.minecraft.skeleton_spawn_egg": "Eskeleto sortzaile arrautza",
  "item.minecraft.skull_banner_pattern": "Zutoihal-estanpatua",
  "item.minecraft.skull_banner_pattern.desc": "Garezur karga",
  "item.minecraft.skull_banner_pattern.new": "Garezur karga zutoihal-estanpatua",
  "item.minecraft.skull_pottery_shard": "Garezur zeramika-puska",
  "item.minecraft.skull_pottery_sherd": "Garezur zeramika-puska",
  "item.minecraft.slime_ball": "Likati-bola",
  "item.minecraft.slime_spawn_egg": "Slime sortzaile arrautza",
  "item.minecraft.smithing_template": "Errementeritza eredua",
  "item.minecraft.smithing_template.applies_to": "Non jar daiteke:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Gehitu lingotea edo kristala",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Gehitu armadura-atal bat",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingoteak eta kristalak",
  "item.minecraft.smithing_template.ingredients": "Osagaiak:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Gehitu netheritazko lingotea",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantezko ekipamendua",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Gehitu diamantezko armadura, arma, edo tresna",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritazko lingotea",
  "item.minecraft.smithing_template.upgrade": "Eguneratu: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer sorgailu arrautza",
  "item.minecraft.snort_pottery_shard": "Usnagile zeramika-puska",
  "item.minecraft.snort_pottery_sherd": "Usnagile zeramika-puska",
  "item.minecraft.snout_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Mutur armadura-edergarria",
  "item.minecraft.snow_golem_spawn_egg": "Elurrezko Golem sortzaile arrautza",
  "item.minecraft.snowball": "Elur bola",
  "item.minecraft.spectral_arrow": "Gezi espektrala",
  "item.minecraft.spider_eye": "Armiarmaren begia",
  "item.minecraft.spider_spawn_egg": "Armiarma sortzaile arrautza",
  "item.minecraft.spire_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Orratz armadura-edergarria",
  "item.minecraft.splash_potion": "Edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.awkward": "Edabe misteriotsu jaurtigarria",
  "item.minecraft.splash_potion.effect.empty": "Edabe ezezagun jaurtigarria",
  "item.minecraft.splash_potion.effect.fire_resistance": "Suaren aurkako edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.harming": "Min egiteko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.healing": "Sendatzeko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.infested": "Infestazioko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.invisibility": "Ikusezintasuneko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.leaping": "Jauzi egiteko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.levitation": "Lebitazioko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.luck": "Zortezko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.mundane": "Edabe arrunt jaurtigarria",
  "item.minecraft.splash_potion.effect.night_vision": "Gaueko ikusmeneko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.oozing": "Lohitzeko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.poison": "Pozoitzeko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.regeneration": "Birsorkuntzako edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.slow_falling": "Erorketa geldoko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.slowness": "Geldotasuneko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.strength": "Indartzeko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.swiftness": "Azkartasuneko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.thick": "Edabe mamitsu jaurtigarria",
  "item.minecraft.splash_potion.effect.turtle_master": "Dortoka maisuaren edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.water": "Ur botila jaurtigarria",
  "item.minecraft.splash_potion.effect.water_breathing": "Urpean arnasteko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.weakness": "Ahultzeko edabe jaurtigarria",
  "item.minecraft.splash_potion.effect.weaving": "Ehungintza astunaren edabe jautigarria",
  "item.minecraft.splash_potion.effect.wind_charged": "Haize-boladazko edabe jaurtigarria",
  "item.minecraft.spruce_boat": "Izeizko txalupa",
  "item.minecraft.spruce_chest_boat": "Izeizko txalupa kutxarekin",
  "item.minecraft.spyglass": "Kataloxa",
  "item.minecraft.squid_spawn_egg": "Txibia sortzaile arrautza",
  "item.minecraft.stick": "Makila",
  "item.minecraft.stone_axe": "Harrizko aizkora",
  "item.minecraft.stone_hoe": "Harrizko aitzurra",
  "item.minecraft.stone_pickaxe": "Harrizko pikotxa",
  "item.minecraft.stone_shovel": "Harrizko pala",
  "item.minecraft.stone_spear": "Harrizko lantza",
  "item.minecraft.stone_sword": "Harrizko ezpata",
  "item.minecraft.stray_spawn_egg": "Eskeleto glazial sortzaile arrautza",
  "item.minecraft.strider_spawn_egg": "Zangokari sortzaile arrautza",
  "item.minecraft.string": "Haria",
  "item.minecraft.sugar": "Azukrea",
  "item.minecraft.suspicious_stew": "Erregosi susmagarria",
  "item.minecraft.sweet_berries": "Fruitu Gozoak",
  "item.minecraft.tadpole_bucket": "Zapaburu ontziratua",
  "item.minecraft.tadpole_spawn_egg": "Zapaburu sortzaile arrautza",
  "item.minecraft.tide_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Itsasaldi armadura-edergarria",
  "item.minecraft.tipped_arrow": "Gezi inpregnatua",
  "item.minecraft.tipped_arrow.effect.awkward": "Gezi inpregnatua",
  "item.minecraft.tipped_arrow.effect.empty": "Efektudun gezi eraikiezina",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Suaren aurkako erresistentzia gezia",
  "item.minecraft.tipped_arrow.effect.harming": "Min Gezia",
  "item.minecraft.tipped_arrow.effect.healing": "Sendatze gezia",
  "item.minecraft.tipped_arrow.effect.infested": "Infestazioaren gezia",
  "item.minecraft.tipped_arrow.effect.invisibility": "Ikusezintasun gezia",
  "item.minecraft.tipped_arrow.effect.leaping": "Jauzi bultzada gezia",
  "item.minecraft.tipped_arrow.effect.levitation": "Lebitazio Gezia",
  "item.minecraft.tipped_arrow.effect.luck": "Zorte gezia",
  "item.minecraft.tipped_arrow.effect.mundane": "Gezi inpregnatua",
  "item.minecraft.tipped_arrow.effect.night_vision": "Gauen ikusteko gezia",
  "item.minecraft.tipped_arrow.effect.oozing": "Isuriaren gezia",
  "item.minecraft.tipped_arrow.effect.poison": "Pozoi gezia",
  "item.minecraft.tipped_arrow.effect.regeneration": "Birsorkuntza gezia",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Erorketa moteleko gezia",
  "item.minecraft.tipped_arrow.effect.slowness": "Geldotasun gezia",
  "item.minecraft.tipped_arrow.effect.strength": "Indar gezia",
  "item.minecraft.tipped_arrow.effect.swiftness": "Azkartasun gezia",
  "item.minecraft.tipped_arrow.effect.thick": "Gezi inpregnatua",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Dortoka maisuaren gezia",
  "item.minecraft.tipped_arrow.effect.water": "Gezi Zipliztintzailea",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Urpean arnasteko gezia",
  "item.minecraft.tipped_arrow.effect.weakness": "Ahultasun gezia",
  "item.minecraft.tipped_arrow.effect.weaving": "Ehungintzaren gezia",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Haize-boladazko gezia",
  "item.minecraft.tnt_minecart": "Bagoneta dinamitarekin",
  "item.minecraft.torchflower_seeds": "Zuzilore haziak",
  "item.minecraft.totem_of_undying": "Hilezkortasun totema",
  "item.minecraft.trader_llama_spawn_egg": "Llama ibiltari agerpen arrautza",
  "item.minecraft.trial_key": "Erronka-giltza",
  "item.minecraft.trident": "Hiruhortza",
  "item.minecraft.tropical_fish": "Arrain tropikala",
  "item.minecraft.tropical_fish_bucket": "Arrain tropikal ontziratua",
  "item.minecraft.tropical_fish_spawn_egg": "Arrain tropikal sortzaile arrautza",
  "item.minecraft.turtle_helmet": "Dortoka-oskola",
  "item.minecraft.turtle_scute": "Dortoka-ezkata",
  "item.minecraft.turtle_spawn_egg": "Dortoka sortzaile arrautza",
  "item.minecraft.vex_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Arima armadura-edergarria",
  "item.minecraft.vex_spawn_egg": "Arima sortzaile arrautza",
  "item.minecraft.villager_spawn_egg": "Herritar sortzaile arrautza",
  "item.minecraft.vindicator_spawn_egg": "Erasotzaile sortzaile arrautza",
  "item.minecraft.wandering_trader_spawn_egg": "Saltzaile ibiltari agerpen arrautza",
  "item.minecraft.ward_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Jagole armadura-edergarria",
  "item.minecraft.warden_spawn_egg": "Jagole itsu sortzaile arrautza",
  "item.minecraft.warped_fungus_on_a_stick": "Onddo okertua makila batean",
  "item.minecraft.water_bucket": "Ur ontzia",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Bidebilatzaile armadura-edergarria",
  "item.minecraft.wheat": "Garia",
  "item.minecraft.wheat_seeds": "Gari haziak",
  "item.minecraft.white_bundle": "Zaku zuria",
  "item.minecraft.white_dye": "Tindagai zuria",
  "item.minecraft.white_harness": "Arnes zuria",
  "item.minecraft.wild_armor_trim_smithing_template": "Errementeritza-txantiloia",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Basati armadura-edergarria",
  "item.minecraft.wind_charge": "Haize-zurrunbiloa",
  "item.minecraft.witch_spawn_egg": "Sorgin sortzaile arrautza",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither eskeleto sortzaile arrautza",
  "item.minecraft.wither_spawn_egg": "Wither sortzaile arrautza",
  "item.minecraft.wolf_armor": "Otso-armadura",
  "item.minecraft.wolf_spawn_egg": "Otso sortzaile arrautza",
  "item.minecraft.wooden_axe": "Egurrezko aizkora",
  "item.minecraft.wooden_hoe": "Egurrezko aitzurra",
  "item.minecraft.wooden_pickaxe": "Egurrezko pikotxa",
  "item.minecraft.wooden_shovel": "Egurrezko pala",
  "item.minecraft.wooden_spear": "Egurrezko lantza",
  "item.minecraft.wooden_sword": "Egurrezko ezpata",
  "item.minecraft.writable_book": "Liburua eta idazluma",
  "item.minecraft.written_book": "Idatzitako liburua",
  "item.minecraft.yellow_bundle": "Zaku horia",
  "item.minecraft.yellow_dye": "Tindagai horia",
  "item.minecraft.yellow_harness": "Arnes horia",
  "item.minecraft.zoglin_spawn_egg": "Zoglin sortzaile arrautza",
  "item.minecraft.zombie_horse_spawn_egg": "Zonbi-zaldi sortzaile arrautza",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zonbi-nautilus sortzaile arrautza",
  "item.minecraft.zombie_spawn_egg": "Zonbi sortzaile arrautza",
  "item.minecraft.zombie_villager_spawn_egg": "Herritar zonbifikatu sortzaile arrautza",
  "item.minecraft.zombified_piglin_spawn_egg": "Piglin zonbifikatu sortzaile arrautza"
}
export const eu_es = items; 
